!(function () {
  function e(e) {
    return e && e.__esModule ? e.default : e;
  }
  var t =
      "undefined" != typeof globalThis
        ? globalThis
        : "undefined" != typeof self
        ? self
        : "undefined" != typeof window
        ? window
        : "undefined" != typeof global
        ? global
        : {},
    i = {},
    s = {},
    n = t.parcelRequire83e8;
  null == n &&
    (((n = function (e) {
      if (e in i) return i[e].exports;
      if (e in s) {
        var t = s[e];
        delete s[e];
        var n = { id: e, exports: {} };
        return (i[e] = n), t.call(n.exports, n, n.exports), n.exports;
      }
      var l = Error("Cannot find module '" + e + "'");
      throw ((l.code = "MODULE_NOT_FOUND"), l);
    }).register = function (e, t) {
      s[e] = t;
    }),
    (t.parcelRequire83e8 = n));
  var l = n.register;
  l("gTegW", function (e, t) {
    !(function (t, i) {
      if (e.exports)
        e.exports = i(
          t,
          n("25P9p"),
          n("dcqvD"),
          n("aWUGO"),
          n("lElEw"),
          n("kFyJV"),
          n("lV5wB")
        );
      else {
        let e = t.Flickity;
        t.Flickity = i(
          t,
          t.EvEmitter,
          t.getSize,
          t.fizzyUIUtils,
          e.Cell,
          e.Slide,
          e.animatePrototype
        );
      }
    })(
      "undefined" != typeof window ? window : e.exports,
      function (e, t, i, s, n, l, r) {
        let { getComputedStyle: o, console: a } = e,
          { jQuery: c } = e,
          d = 0,
          u = {};
        function h(e, t) {
          let i = s.getQueryElement(e);
          if (!i) {
            a && a.error(`Bad element for Flickity: ${i || e}`);
            return;
          }
          if (((this.element = i), this.element.flickityGUID)) {
            let e = u[this.element.flickityGUID];
            return e && e.option(t), e;
          }
          c && (this.$element = c(this.element)),
            (this.options = { ...this.constructor.defaults }),
            this.option(t),
            this._create();
        }
        (h.defaults = {
          accessibility: !0,
          cellAlign: "center",
          freeScrollFriction: 0.075,
          friction: 0.28,
          namespaceJQueryEvents: !0,
          percentPosition: !0,
          resize: !0,
          selectedAttraction: 0.025,
          setGallerySize: !0,
        }),
          (h.create = {});
        let g = h.prototype;
        Object.assign(g, t.prototype),
          (g._create = function () {
            let { resize: t, watchCSS: i, rightToLeft: s } = this.options,
              n = (this.guid = ++d);
            for (let l in ((this.element.flickityGUID = n),
            (u[n] = this),
            (this.selectedIndex = 0),
            (this.restingFrames = 0),
            (this.x = 0),
            (this.velocity = 0),
            (this.beginMargin = s ? "marginRight" : "marginLeft"),
            (this.endMargin = s ? "marginLeft" : "marginRight"),
            (this.viewport = document.createElement("div")),
            (this.viewport.className = "flickity-viewport"),
            this._createSlider(),
            (this.focusableElems = [this.element]),
            (t || i) && e.addEventListener("resize", this),
            this.options.on)) {
              let e = this.options.on[l];
              this.on(l, e);
            }
            for (let e in h.create) h.create[e].call(this);
            i ? this.watchCSS() : this.activate();
          }),
          (g.option = function (e) {
            Object.assign(this.options, e);
          }),
          (g.activate = function () {
            if (this.isActive) return;
            (this.isActive = !0),
              this.element.classList.add("flickity-enabled"),
              this.options.rightToLeft &&
                this.element.classList.add("flickity-rtl"),
              this.getSize();
            let e = this._filterFindCellElements(this.element.children);
            this.slider.append(...e),
              this.viewport.append(this.slider),
              this.element.append(this.viewport),
              this.reloadCells(),
              this.options.accessibility &&
                ((this.element.tabIndex = 0),
                this.element.addEventListener("keydown", this)),
              this.emitEvent("activate"),
              this.selectInitialIndex(),
              (this.isInitActivated = !0),
              this.dispatchEvent("ready");
          }),
          (g._createSlider = function () {
            let e = document.createElement("div");
            (e.className = "flickity-slider"), (this.slider = e);
          }),
          (g._filterFindCellElements = function (e) {
            return s.filterFindElements(e, this.options.cellSelector);
          }),
          (g.reloadCells = function () {
            (this.cells = this._makeCells(this.slider.children)),
              this.positionCells(),
              this._updateWrapShiftCells(),
              this.setGallerySize();
          }),
          (g._makeCells = function (e) {
            return this._filterFindCellElements(e).map((e) => new n(e));
          }),
          (g.getLastCell = function () {
            return this.cells[this.cells.length - 1];
          }),
          (g.getLastSlide = function () {
            return this.slides[this.slides.length - 1];
          }),
          (g.positionCells = function () {
            this._sizeCells(this.cells), this._positionCells(0);
          }),
          (g._positionCells = function (e) {
            (e = e || 0), (this.maxCellHeight = (e && this.maxCellHeight) || 0);
            let t = 0;
            if (e > 0) {
              let i = this.cells[e - 1];
              t = i.x + i.size.outerWidth;
            }
            this.cells.slice(e).forEach((e) => {
              (e.x = t),
                this._renderCellPosition(e, t),
                (t += e.size.outerWidth),
                (this.maxCellHeight = Math.max(
                  e.size.outerHeight,
                  this.maxCellHeight
                ));
            }),
              (this.slideableWidth = t),
              this.updateSlides(),
              this._containSlides(),
              (this.slidesWidth = this.cells.length
                ? this.getLastSlide().target - this.slides[0].target
                : 0);
          }),
          (g._renderCellPosition = function (e, t) {
            let i = t * (this.options.rightToLeft ? -1 : 1);
            this.options.percentPosition &&
              (i *= this.size.innerWidth / e.size.width);
            let s = this.getPositionValue(i);
            e.element.style.transform = `translateX( ${s} )`;
          }),
          (g._sizeCells = function (e) {
            e.forEach((e) => e.getSize());
          }),
          (g.updateSlides = function () {
            if (((this.slides = []), !this.cells.length)) return;
            let { beginMargin: e, endMargin: t } = this,
              i = new l(e, t, this.cellAlign);
            this.slides.push(i);
            let s = this._getCanCellFit();
            this.cells.forEach((n, r) => {
              if (!i.cells.length) {
                i.addCell(n);
                return;
              }
              s(
                r,
                i.outerWidth - i.firstMargin + (n.size.outerWidth - n.size[t])
              ) ||
                (i.updateTarget(),
                (i = new l(e, t, this.cellAlign)),
                this.slides.push(i)),
                i.addCell(n);
            }),
              i.updateTarget(),
              this.updateSelectedSlide();
          }),
          (g._getCanCellFit = function () {
            let { groupCells: e } = this.options;
            if (!e) return () => !1;
            if ("number" == typeof e) {
              let t = parseInt(e, 10);
              return (e) => e % t != 0;
            }
            let t = 1,
              i = "string" == typeof e && e.match(/^(\d+)%$/);
            i && (t = parseInt(i[1], 10) / 100);
            let s = (this.size.innerWidth + 1) * t;
            return (e, t) => t <= s;
          }),
          (g._init = g.reposition =
            function () {
              this.positionCells(), this.positionSliderAtSelected();
            }),
          (g.getSize = function () {
            (this.size = i(this.element)),
              this.setCellAlign(),
              (this.cursorPosition = this.size.innerWidth * this.cellAlign);
          });
        let p = { left: 0, center: 0.5, right: 1 };
        (g.setCellAlign = function () {
          let { cellAlign: e, rightToLeft: t } = this.options,
            i = p[e];
          (this.cellAlign = void 0 !== i ? i : e),
            t && (this.cellAlign = 1 - this.cellAlign);
        }),
          (g.setGallerySize = function () {
            if (!this.options.setGallerySize) return;
            let e =
              this.options.adaptiveHeight && this.selectedSlide
                ? this.selectedSlide.height
                : this.maxCellHeight;
            this.viewport.style.height = `${e}px`;
          }),
          (g._updateWrapShiftCells = function () {
            if (((this.isWrapping = this.getIsWrapping()), !this.isWrapping))
              return;
            this._unshiftCells(this.beforeShiftCells),
              this._unshiftCells(this.afterShiftCells);
            let e = this.cursorPosition,
              t = this.cells.length - 1;
            this.beforeShiftCells = this._getGapCells(e, t, -1);
            let i = this.size.innerWidth - this.cursorPosition;
            this.afterShiftCells = this._getGapCells(i, 0, 1);
          }),
          (g.getIsWrapping = function () {
            let { wrapAround: e } = this.options;
            if (!e || this.slides.length < 2) return !1;
            if ("fill" !== e) return !0;
            let t = this.slideableWidth - this.size.innerWidth;
            if (t > this.size.innerWidth) return !0;
            for (let e of this.cells) if (e.size.outerWidth > t) return !1;
            return !0;
          }),
          (g._getGapCells = function (e, t, i) {
            let s = [];
            for (; e > 0; ) {
              let n = this.cells[t];
              if (!n) break;
              s.push(n), (t += i), (e -= n.size.outerWidth);
            }
            return s;
          }),
          (g._containSlides = function () {
            if (
              !(this.options.contain && !this.isWrapping && this.cells.length)
            )
              return;
            let e =
              this.slideableWidth - this.getLastCell().size[this.endMargin];
            if (e < this.size.innerWidth)
              this.slides.forEach((t) => {
                t.target = e * this.cellAlign;
              });
            else {
              let t =
                  this.cursorPosition + this.cells[0].size[this.beginMargin],
                i = e - this.size.innerWidth * (1 - this.cellAlign);
              this.slides.forEach((e) => {
                (e.target = Math.max(e.target, t)),
                  (e.target = Math.min(e.target, i));
              });
            }
          }),
          (g.dispatchEvent = function (e, t, i) {
            let s = t ? [t].concat(i) : i;
            if ((this.emitEvent(e, s), c && this.$element)) {
              let s = (e += this.options.namespaceJQueryEvents
                ? ".flickity"
                : "");
              if (t) {
                let i = new c.Event(t);
                (i.type = e), (s = i);
              }
              this.$element.trigger(s, i);
            }
          });
        let m = [
            "dragStart",
            "dragMove",
            "dragEnd",
            "pointerDown",
            "pointerMove",
            "pointerEnd",
            "staticClick",
          ],
          f = g.emitEvent;
        (g.emitEvent = function (e, t) {
          if ("staticClick" === e) {
            let e = this.getParentCell(t[0].target),
              i = e && e.element,
              s = e && this.cells.indexOf(e);
            t = t.concat(i, s);
          }
          if ((f.call(this, e, t), !m.includes(e) || !c || !this.$element))
            return;
          e += this.options.namespaceJQueryEvents ? ".flickity" : "";
          let i = t.shift(0),
            s = new c.Event(i);
          (s.type = e), this.$element.trigger(s, t);
        }),
          (g.select = function (e, t, i) {
            if (
              !this.isActive ||
              ((e = parseInt(e, 10)),
              this._wrapSelect(e),
              (this.isWrapping || t) && (e = s.modulo(e, this.slides.length)),
              !this.slides[e])
            )
              return;
            let n = this.selectedIndex;
            (this.selectedIndex = e),
              this.updateSelectedSlide(),
              i ? this.positionSliderAtSelected() : this.startAnimation(),
              this.options.adaptiveHeight && this.setGallerySize(),
              this.dispatchEvent("select", null, [e]),
              e !== n && this.dispatchEvent("change", null, [e]);
          }),
          (g._wrapSelect = function (e) {
            if (!this.isWrapping) return;
            let {
              selectedIndex: t,
              slideableWidth: i,
              slides: { length: n },
            } = this;
            if (!this.isDragSelect) {
              let i = s.modulo(e, n),
                l = Math.abs(i - t),
                r = Math.abs(i + n - t),
                o = Math.abs(i - n - t);
              r < l ? (e += n) : o < l && (e -= n);
            }
            e < 0 ? (this.x -= i) : e >= n && (this.x += i);
          }),
          (g.previous = function (e, t) {
            this.select(this.selectedIndex - 1, e, t);
          }),
          (g.next = function (e, t) {
            this.select(this.selectedIndex + 1, e, t);
          }),
          (g.updateSelectedSlide = function () {
            let e = this.slides[this.selectedIndex];
            e &&
              (this.unselectSelectedSlide(),
              (this.selectedSlide = e),
              e.select(),
              (this.selectedCells = e.cells),
              (this.selectedElements = e.getCellElements()),
              (this.selectedCell = e.cells[0]),
              (this.selectedElement = this.selectedElements[0]));
          }),
          (g.unselectSelectedSlide = function () {
            this.selectedSlide && this.selectedSlide.unselect();
          }),
          (g.selectInitialIndex = function () {
            let e = this.options.initialIndex;
            if (this.isInitActivated) {
              this.select(this.selectedIndex, !1, !0);
              return;
            }
            if (e && "string" == typeof e && this.queryCell(e)) {
              this.selectCell(e, !1, !0);
              return;
            }
            let t = 0;
            e && this.slides[e] && (t = e), this.select(t, !1, !0);
          }),
          (g.selectCell = function (e, t, i) {
            let s = this.queryCell(e);
            if (!s) return;
            let n = this.getCellSlideIndex(s);
            this.select(n, t, i);
          }),
          (g.getCellSlideIndex = function (e) {
            let t = this.slides.find((t) => t.cells.includes(e));
            return this.slides.indexOf(t);
          }),
          (g.getCell = function (e) {
            for (let t of this.cells) if (t.element === e) return t;
          }),
          (g.getCells = function (e) {
            return (e = s.makeArray(e))
              .map((e) => this.getCell(e))
              .filter(Boolean);
          }),
          (g.getCellElements = function () {
            return this.cells.map((e) => e.element);
          }),
          (g.getParentCell = function (e) {
            let t = this.getCell(e);
            if (t) return t;
            let i = e.closest(".flickity-slider > *");
            return this.getCell(i);
          }),
          (g.getAdjacentCellElements = function (e, t) {
            if (!e) return this.selectedSlide.getCellElements();
            t = void 0 === t ? this.selectedIndex : t;
            let i = this.slides.length;
            if (1 + 2 * e >= i) return this.getCellElements();
            let n = [];
            for (let l = t - e; l <= t + e; l++) {
              let e = this.isWrapping ? s.modulo(l, i) : l,
                t = this.slides[e];
              t && (n = n.concat(t.getCellElements()));
            }
            return n;
          }),
          (g.queryCell = function (e) {
            return "number" == typeof e
              ? this.cells[e]
              : ("string" != typeof e ||
                  e.match(/^[#.]?[\d/]/) ||
                  (e = this.element.querySelector(e)),
                this.getCell(e));
          }),
          (g.uiChange = function () {
            this.emitEvent("uiChange");
          }),
          (g.onresize = function () {
            this.watchCSS(), this.resize();
          }),
          s.debounceMethod(h, "onresize", 150),
          (g.resize = function () {
            if (!this.isActive || this.isAnimating || this.isDragging) return;
            this.getSize(),
              this.isWrapping &&
                (this.x = s.modulo(this.x, this.slideableWidth)),
              this.positionCells(),
              this._updateWrapShiftCells(),
              this.setGallerySize(),
              this.emitEvent("resize");
            let e = this.selectedElements && this.selectedElements[0];
            this.selectCell(e, !1, !0);
          }),
          (g.watchCSS = function () {
            this.options.watchCSS &&
              (o(this.element, ":after").content.includes("flickity")
                ? this.activate()
                : this.deactivate());
          }),
          (g.onkeydown = function (e) {
            let { activeElement: t } = document,
              i = h.keyboardHandlers[e.key];
            this.options.accessibility &&
              t &&
              i &&
              this.focusableElems.some((e) => t === e) &&
              i.call(this);
          }),
          (h.keyboardHandlers = {
            ArrowLeft: function () {
              this.uiChange(),
                this[this.options.rightToLeft ? "next" : "previous"]();
            },
            ArrowRight: function () {
              this.uiChange(),
                this[this.options.rightToLeft ? "previous" : "next"]();
            },
          }),
          (g.focus = function () {
            this.element.focus({ preventScroll: !0 });
          }),
          (g.deactivate = function () {
            this.isActive &&
              (this.element.classList.remove("flickity-enabled"),
              this.element.classList.remove("flickity-rtl"),
              this.unselectSelectedSlide(),
              this.cells.forEach((e) => e.destroy()),
              this.viewport.remove(),
              this.element.append(...this.slider.children),
              this.options.accessibility &&
                (this.element.removeAttribute("tabIndex"),
                this.element.removeEventListener("keydown", this)),
              (this.isActive = !1),
              this.emitEvent("deactivate"));
          }),
          (g.destroy = function () {
            this.deactivate(),
              e.removeEventListener("resize", this),
              this.allOff(),
              this.emitEvent("destroy"),
              c && this.$element && c.removeData(this.element, "flickity"),
              delete this.element.flickityGUID,
              delete u[this.guid];
          }),
          Object.assign(g, r),
          (h.data = function (e) {
            if ((e = s.getQueryElement(e))) return u[e.flickityGUID];
          }),
          s.htmlInit(h, "flickity");
        let { jQueryBridget: v } = e;
        return (
          c && v && v("flickity", h, c),
          (h.setJQuery = function (e) {
            c = e;
          }),
          (h.Cell = n),
          (h.Slide = l),
          h
        );
      }
    );
  }),
    l("25P9p", function (e, t) {
      var i, s;
      (i = "undefined" != typeof window ? window : e.exports),
        (s = function () {
          function e() {}
          let t = e.prototype;
          return (
            (t.on = function (e, t) {
              if (!e || !t) return this;
              let i = (this._events = this._events || {}),
                s = (i[e] = i[e] || []);
              return s.includes(t) || s.push(t), this;
            }),
            (t.once = function (e, t) {
              if (!e || !t) return this;
              this.on(e, t);
              let i = (this._onceEvents = this._onceEvents || {});
              return ((i[e] = i[e] || {})[t] = !0), this;
            }),
            (t.off = function (e, t) {
              let i = this._events && this._events[e];
              if (!i || !i.length) return this;
              let s = i.indexOf(t);
              return -1 != s && i.splice(s, 1), this;
            }),
            (t.emitEvent = function (e, t) {
              let i = this._events && this._events[e];
              if (!i || !i.length) return this;
              (i = i.slice(0)), (t = t || []);
              let s = this._onceEvents && this._onceEvents[e];
              for (let n of i)
                s && s[n] && (this.off(e, n), delete s[n]), n.apply(this, t);
              return this;
            }),
            (t.allOff = function () {
              return delete this._events, delete this._onceEvents, this;
            }),
            e
          );
        }),
        e.exports ? (e.exports = s()) : (i.EvEmitter = s());
    }),
    l("dcqvD", function (e, t) {
      var i, s;
      (i = window),
        (s = function () {
          function e(e) {
            let t = parseFloat(e);
            return -1 == e.indexOf("%") && !isNaN(t) && t;
          }
          let t = [
            "paddingLeft",
            "paddingRight",
            "paddingTop",
            "paddingBottom",
            "marginLeft",
            "marginRight",
            "marginTop",
            "marginBottom",
            "borderLeftWidth",
            "borderRightWidth",
            "borderTopWidth",
            "borderBottomWidth",
          ];
          return (
            t.length,
            function (i) {
              if (
                ("string" == typeof i && (i = document.querySelector(i)),
                !(i && "object" == typeof i && i.nodeType))
              )
                return;
              let s = getComputedStyle(i);
              if ("none" == s.display) {
                let e;
                return (
                  (e = {
                    width: 0,
                    height: 0,
                    innerWidth: 0,
                    innerHeight: 0,
                    outerWidth: 0,
                    outerHeight: 0,
                  }),
                  t.forEach((t) => {
                    e[t] = 0;
                  }),
                  e
                );
              }
              let n = {};
              (n.width = i.offsetWidth), (n.height = i.offsetHeight);
              let l = (n.isBorderBox = "border-box" == s.boxSizing);
              t.forEach((e) => {
                let t = parseFloat(s[e]);
                n[e] = isNaN(t) ? 0 : t;
              });
              let r = n.paddingLeft + n.paddingRight,
                o = n.paddingTop + n.paddingBottom,
                a = n.marginLeft + n.marginRight,
                c = n.marginTop + n.marginBottom,
                d = n.borderLeftWidth + n.borderRightWidth,
                u = n.borderTopWidth + n.borderBottomWidth,
                h = e(s.width);
              !1 !== h && (n.width = h + (l ? 0 : r + d));
              let g = e(s.height);
              return (
                !1 !== g && (n.height = g + (l ? 0 : o + u)),
                (n.innerWidth = n.width - (r + d)),
                (n.innerHeight = n.height - (o + u)),
                (n.outerWidth = n.width + a),
                (n.outerHeight = n.height + c),
                n
              );
            }
          );
        }),
        e.exports ? (e.exports = s()) : (i.getSize = s());
    }),
    l("aWUGO", function (e, t) {
      var i, s;
      (i = e.exports),
        (s = function (e) {
          let t = {};
          (t.extend = function (e, t) {
            return Object.assign(e, t);
          }),
            (t.modulo = function (e, t) {
              return ((e % t) + t) % t;
            }),
            (t.makeArray = function (e) {
              return Array.isArray(e)
                ? e
                : null == e
                ? []
                : "object" == typeof e && "number" == typeof e.length
                ? [...e]
                : [e];
            }),
            (t.removeFrom = function (e, t) {
              let i = e.indexOf(t);
              -1 != i && e.splice(i, 1);
            }),
            (t.getParent = function (e, t) {
              for (; e.parentNode && e != document.body; )
                if ((e = e.parentNode).matches(t)) return e;
            }),
            (t.getQueryElement = function (e) {
              return "string" == typeof e ? document.querySelector(e) : e;
            }),
            (t.handleEvent = function (e) {
              let t = "on" + e.type;
              this[t] && this[t](e);
            }),
            (t.filterFindElements = function (e, i) {
              return (e = t.makeArray(e))
                .filter((e) => e instanceof HTMLElement)
                .reduce((e, t) => {
                  if (!i) return e.push(t), e;
                  t.matches(i) && e.push(t);
                  let s = t.querySelectorAll(i);
                  return (e = e.concat(...s));
                }, []);
            }),
            (t.debounceMethod = function (e, t, i) {
              i = i || 100;
              let s = e.prototype[t],
                n = t + "Timeout";
              e.prototype[t] = function () {
                clearTimeout(this[n]);
                let e = arguments;
                this[n] = setTimeout(() => {
                  s.apply(this, e), delete this[n];
                }, i);
              };
            }),
            (t.docReady = function (e) {
              let t = document.readyState;
              "complete" == t || "interactive" == t
                ? setTimeout(e)
                : document.addEventListener("DOMContentLoaded", e);
            }),
            (t.toDashed = function (e) {
              return e
                .replace(/(.)([A-Z])/g, function (e, t, i) {
                  return t + "-" + i;
                })
                .toLowerCase();
            });
          let i = e.console;
          return (
            (t.htmlInit = function (s, n) {
              t.docReady(function () {
                let l = "data-" + t.toDashed(n),
                  r = document.querySelectorAll(`[${l}]`),
                  o = e.jQuery;
                [...r].forEach((e) => {
                  let t,
                    r = e.getAttribute(l);
                  try {
                    t = r && JSON.parse(r);
                  } catch (t) {
                    i && i.error(`Error parsing ${l} on ${e.className}: ${t}`);
                    return;
                  }
                  let a = new s(e, t);
                  o && o.data(e, n, a);
                });
              });
            }),
            t
          );
        }),
        e.exports ? (e.exports = s(i)) : (i.fizzyUIUtils = s(i));
    }),
    l("lElEw", function (e, t) {
      var i, s;
      (i = "undefined" != typeof window ? window : e.exports),
        (s = function (e) {
          let t = "flickity-cell";
          function i(e) {
            (this.element = e),
              this.element.classList.add(t),
              (this.x = 0),
              this.unselect();
          }
          let s = i.prototype;
          return (
            (s.destroy = function () {
              this.unselect(),
                this.element.classList.remove(t),
                (this.element.style.transform = ""),
                this.element.removeAttribute("aria-hidden");
            }),
            (s.getSize = function () {
              this.size = e(this.element);
            }),
            (s.select = function () {
              this.element.classList.add("is-selected"),
                this.element.removeAttribute("aria-hidden");
            }),
            (s.unselect = function () {
              this.element.classList.remove("is-selected"),
                this.element.setAttribute("aria-hidden", "true");
            }),
            (s.remove = function () {
              this.element.remove();
            }),
            i
          );
        }),
        e.exports
          ? (e.exports = s(n("dcqvD")))
          : ((i.Flickity = i.Flickity || {}), (i.Flickity.Cell = s(i.getSize)));
    }),
    l("kFyJV", function (e, t) {
      var i, s;
      (i = "undefined" != typeof window ? window : e.exports),
        (s = function () {
          function e(e, t, i) {
            (this.beginMargin = e),
              (this.endMargin = t),
              (this.cellAlign = i),
              (this.cells = []),
              (this.outerWidth = 0),
              (this.height = 0);
          }
          let t = e.prototype;
          return (
            (t.addCell = function (e) {
              this.cells.push(e),
                (this.outerWidth += e.size.outerWidth),
                (this.height = Math.max(e.size.outerHeight, this.height)),
                1 === this.cells.length &&
                  ((this.x = e.x),
                  (this.firstMargin = e.size[this.beginMargin]));
            }),
            (t.updateTarget = function () {
              let e = this.getLastCell(),
                t = e ? e.size[this.endMargin] : 0,
                i = this.outerWidth - (this.firstMargin + t);
              this.target = this.x + this.firstMargin + i * this.cellAlign;
            }),
            (t.getLastCell = function () {
              return this.cells[this.cells.length - 1];
            }),
            (t.select = function () {
              this.cells.forEach((e) => e.select());
            }),
            (t.unselect = function () {
              this.cells.forEach((e) => e.unselect());
            }),
            (t.getCellElements = function () {
              return this.cells.map((e) => e.element);
            }),
            e
          );
        }),
        e.exports
          ? (e.exports = s())
          : ((i.Flickity = i.Flickity || {}), (i.Flickity.Slide = s()));
    }),
    l("lV5wB", function (e, t) {
      var i, s;
      (i = "undefined" != typeof window ? window : e.exports),
        (s = function (e) {
          let t = {};
          return (
            (t.startAnimation = function () {
              this.isAnimating ||
                ((this.isAnimating = !0),
                (this.restingFrames = 0),
                this.animate());
            }),
            (t.animate = function () {
              this.applyDragForce(), this.applySelectedAttraction();
              let e = this.x;
              this.integratePhysics(),
                this.positionSlider(),
                this.settle(e),
                this.isAnimating && requestAnimationFrame(() => this.animate());
            }),
            (t.positionSlider = function () {
              let t = this.x;
              this.isWrapping &&
                ((t = e.modulo(t, this.slideableWidth) - this.slideableWidth),
                this.shiftWrapCells(t)),
                this.setTranslateX(t, this.isAnimating),
                this.dispatchScrollEvent();
            }),
            (t.setTranslateX = function (e, t) {
              (e += this.cursorPosition), this.options.rightToLeft && (e = -e);
              let i = this.getPositionValue(e);
              this.slider.style.transform = t
                ? `translate3d(${i},0,0)`
                : `translateX(${i})`;
            }),
            (t.dispatchScrollEvent = function () {
              let e = this.slides[0];
              if (!e) return;
              let t = -this.x - e.target,
                i = t / this.slidesWidth;
              this.dispatchEvent("scroll", null, [i, t]);
            }),
            (t.positionSliderAtSelected = function () {
              this.cells.length &&
                ((this.x = -this.selectedSlide.target),
                (this.velocity = 0),
                this.positionSlider());
            }),
            (t.getPositionValue = function (e) {
              return this.options.percentPosition
                ? 0.01 * Math.round((e / this.size.innerWidth) * 1e4) + "%"
                : Math.round(e) + "px";
            }),
            (t.settle = function (e) {
              !this.isPointerDown &&
                Math.round(100 * this.x) === Math.round(100 * e) &&
                this.restingFrames++,
                this.restingFrames > 2 &&
                  ((this.isAnimating = !1),
                  delete this.isFreeScrolling,
                  this.positionSlider(),
                  this.dispatchEvent("settle", null, [this.selectedIndex]));
            }),
            (t.shiftWrapCells = function (e) {
              let t = this.cursorPosition + e;
              this._shiftCells(this.beforeShiftCells, t, -1);
              let i =
                this.size.innerWidth -
                (e + this.slideableWidth + this.cursorPosition);
              this._shiftCells(this.afterShiftCells, i, 1);
            }),
            (t._shiftCells = function (e, t, i) {
              e.forEach((e) => {
                let s = t > 0 ? i : 0;
                this._wrapShiftCell(e, s), (t -= e.size.outerWidth);
              });
            }),
            (t._unshiftCells = function (e) {
              e && e.length && e.forEach((e) => this._wrapShiftCell(e, 0));
            }),
            (t._wrapShiftCell = function (e, t) {
              this._renderCellPosition(e, e.x + this.slideableWidth * t);
            }),
            (t.integratePhysics = function () {
              (this.x += this.velocity),
                (this.velocity *= this.getFrictionFactor());
            }),
            (t.applyForce = function (e) {
              this.velocity += e;
            }),
            (t.getFrictionFactor = function () {
              return (
                1 -
                this.options[
                  this.isFreeScrolling ? "freeScrollFriction" : "friction"
                ]
              );
            }),
            (t.getRestingPosition = function () {
              return this.x + this.velocity / (1 - this.getFrictionFactor());
            }),
            (t.applyDragForce = function () {
              if (!this.isDraggable || !this.isPointerDown) return;
              let e = this.dragX - this.x - this.velocity;
              this.applyForce(e);
            }),
            (t.applySelectedAttraction = function () {
              if (
                (this.isDraggable && this.isPointerDown) ||
                this.isFreeScrolling ||
                !this.slides.length
              )
                return;
              let e =
                (-1 * this.selectedSlide.target - this.x) *
                this.options.selectedAttraction;
              this.applyForce(e);
            }),
            t
          );
        }),
        e.exports
          ? (e.exports = s(n("aWUGO")))
          : ((i.Flickity = i.Flickity || {}),
            (i.Flickity.animatePrototype = s(i.fizzyUIUtils)));
    }),
    l("iy2JW", function (e, t) {
      var i, s;
      (i = "undefined" != typeof window ? window : e.exports),
        (s = function (e, t, i, s) {
          Object.assign(t.defaults, { draggable: ">1", dragThreshold: 3 });
          let n = t.prototype;
          function l() {
            return { x: e.pageXOffset, y: e.pageYOffset };
          }
          return (
            Object.assign(n, i.prototype),
            (n.touchActionValue = ""),
            (t.create.drag = function () {
              this.on("activate", this.onActivateDrag),
                this.on("uiChange", this._uiChangeDrag),
                this.on("deactivate", this.onDeactivateDrag),
                this.on("cellChange", this.updateDraggable),
                this.on("pointerDown", this.handlePointerDown),
                this.on("pointerUp", this.handlePointerUp),
                this.on("pointerDown", this.handlePointerDone),
                this.on("dragStart", this.handleDragStart),
                this.on("dragMove", this.handleDragMove),
                this.on("dragEnd", this.handleDragEnd),
                this.on("staticClick", this.handleStaticClick);
            }),
            (n.onActivateDrag = function () {
              (this.handles = [this.viewport]),
                this.bindHandles(),
                this.updateDraggable();
            }),
            (n.onDeactivateDrag = function () {
              this.unbindHandles(),
                this.element.classList.remove("is-draggable");
            }),
            (n.updateDraggable = function () {
              ">1" === this.options.draggable
                ? (this.isDraggable = this.slides.length > 1)
                : (this.isDraggable = this.options.draggable),
                this.element.classList.toggle("is-draggable", this.isDraggable);
            }),
            (n._uiChangeDrag = function () {
              delete this.isFreeScrolling;
            }),
            (n.handlePointerDown = function (t) {
              if (!this.isDraggable) {
                this.bindActivePointerEvents(t);
                return;
              }
              let i = "touchstart" === t.type,
                s = "touch" === t.pointerType,
                n = t.target.matches("input, textarea, select");
              i || s || n || t.preventDefault(),
                n || this.focus(),
                document.activeElement !== this.element &&
                  document.activeElement.blur(),
                (this.dragX = this.x),
                this.viewport.classList.add("is-pointer-down"),
                (this.pointerDownScroll = l()),
                e.addEventListener("scroll", this),
                this.bindActivePointerEvents(t);
            }),
            (n.hasDragStarted = function (e) {
              return Math.abs(e.x) > this.options.dragThreshold;
            }),
            (n.handlePointerUp = function () {
              delete this.isTouchScrolling,
                this.viewport.classList.remove("is-pointer-down");
            }),
            (n.handlePointerDone = function () {
              e.removeEventListener("scroll", this),
                delete this.pointerDownScroll;
            }),
            (n.handleDragStart = function () {
              this.isDraggable &&
                ((this.dragStartPosition = this.x),
                this.startAnimation(),
                e.removeEventListener("scroll", this));
            }),
            (n.handleDragMove = function (e, t, i) {
              if (!this.isDraggable) return;
              e.preventDefault(), (this.previousDragX = this.dragX);
              let s = this.options.rightToLeft ? -1 : 1;
              this.isWrapping && (i.x %= this.slideableWidth);
              let n = this.dragStartPosition + i.x * s;
              if (!this.isWrapping) {
                let e = Math.max(
                  -this.slides[0].target,
                  this.dragStartPosition
                );
                n = n > e ? (n + e) * 0.5 : n;
                let t = Math.min(
                  -this.getLastSlide().target,
                  this.dragStartPosition
                );
                n = n < t ? (n + t) * 0.5 : n;
              }
              (this.dragX = n), (this.dragMoveTime = new Date());
            }),
            (n.handleDragEnd = function () {
              if (!this.isDraggable) return;
              let { freeScroll: e } = this.options;
              e && (this.isFreeScrolling = !0);
              let t = this.dragEndRestingSelect();
              if (e && !this.isWrapping) {
                let e = this.getRestingPosition();
                this.isFreeScrolling =
                  -e > this.slides[0].target && -e < this.getLastSlide().target;
              } else
                e ||
                  t !== this.selectedIndex ||
                  (t += this.dragEndBoostSelect());
              delete this.previousDragX,
                (this.isDragSelect = this.isWrapping),
                this.select(t),
                delete this.isDragSelect;
            }),
            (n.dragEndRestingSelect = function () {
              let e = this.getRestingPosition(),
                t = Math.abs(this.getSlideDistance(-e, this.selectedIndex)),
                i = this._getClosestResting(e, t, 1),
                s = this._getClosestResting(e, t, -1);
              return i.distance < s.distance ? i.index : s.index;
            }),
            (n._getClosestResting = function (e, t, i) {
              let s = this.selectedIndex,
                n = 1 / 0,
                l =
                  this.options.contain && !this.isWrapping
                    ? (e, t) => e <= t
                    : (e, t) => e < t;
              for (
                ;
                l(t, n) &&
                ((s += i),
                (n = t),
                null !== (t = this.getSlideDistance(-e, s)));

              )
                t = Math.abs(t);
              return { distance: n, index: s - i };
            }),
            (n.getSlideDistance = function (e, t) {
              let i = this.slides.length,
                n = this.options.wrapAround && i > 1,
                l = n ? s.modulo(t, i) : t,
                r = this.slides[l];
              if (!r) return null;
              let o = n ? this.slideableWidth * Math.floor(t / i) : 0;
              return e - (r.target + o);
            }),
            (n.dragEndBoostSelect = function () {
              if (
                void 0 === this.previousDragX ||
                !this.dragMoveTime ||
                new Date() - this.dragMoveTime > 100
              )
                return 0;
              let e = this.getSlideDistance(-this.dragX, this.selectedIndex),
                t = this.previousDragX - this.dragX;
              return e > 0 && t > 0 ? 1 : e < 0 && t < 0 ? -1 : 0;
            }),
            (n.onscroll = function () {
              let e = l(),
                t = this.pointerDownScroll.x - e.x,
                i = this.pointerDownScroll.y - e.y;
              (Math.abs(t) > 3 || Math.abs(i) > 3) && this.pointerDone();
            }),
            t
          );
        }),
        e.exports
          ? (e.exports = s(i, n("gTegW"), n("6ui6x"), n("aWUGO")))
          : (i.Flickity = s(i, i.Flickity, i.Unidragger, i.fizzyUIUtils));
    }),
    l("6ui6x", function (e, t) {
      var i, s;
      (i = "undefined" != typeof window ? window : e.exports),
        (s = function (e, t) {
          let i, s;
          function n() {}
          let l = (n.prototype = Object.create(t.prototype));
          (l.handleEvent = function (e) {
            let t = "on" + e.type;
            this[t] && this[t](e);
          }),
            "ontouchstart" in e
              ? ((i = "touchstart"),
                (s = ["touchmove", "touchend", "touchcancel"]))
              : e.PointerEvent
              ? ((i = "pointerdown"),
                (s = ["pointermove", "pointerup", "pointercancel"]))
              : ((i = "mousedown"), (s = ["mousemove", "mouseup"])),
            (l.touchActionValue = "none"),
            (l.bindHandles = function () {
              this._bindHandles("addEventListener", this.touchActionValue);
            }),
            (l.unbindHandles = function () {
              this._bindHandles("removeEventListener", "");
            }),
            (l._bindHandles = function (t, s) {
              this.handles.forEach((n) => {
                n[t](i, this),
                  n[t]("click", this),
                  e.PointerEvent && (n.style.touchAction = s);
              });
            }),
            (l.bindActivePointerEvents = function () {
              s.forEach((t) => {
                e.addEventListener(t, this);
              });
            }),
            (l.unbindActivePointerEvents = function () {
              s.forEach((t) => {
                e.removeEventListener(t, this);
              });
            }),
            (l.withPointer = function (e, t) {
              t.pointerId === this.pointerIdentifier && this[e](t, t);
            }),
            (l.withTouch = function (e, t) {
              let i;
              for (let e of t.changedTouches)
                e.identifier === this.pointerIdentifier && (i = e);
              i && this[e](t, i);
            }),
            (l.onmousedown = function (e) {
              this.pointerDown(e, e);
            }),
            (l.ontouchstart = function (e) {
              this.pointerDown(e, e.changedTouches[0]);
            }),
            (l.onpointerdown = function (e) {
              this.pointerDown(e, e);
            });
          let r = ["TEXTAREA", "INPUT", "SELECT", "OPTION"],
            o = ["radio", "checkbox", "button", "submit", "image", "file"];
          return (
            (l.pointerDown = function (e, t) {
              let i = r.includes(e.target.nodeName),
                s = o.includes(e.target.type);
              this.isPointerDown ||
                e.button ||
                (i && !s) ||
                ((this.isPointerDown = !0),
                (this.pointerIdentifier =
                  void 0 !== t.pointerId ? t.pointerId : t.identifier),
                (this.pointerDownPointer = { pageX: t.pageX, pageY: t.pageY }),
                this.bindActivePointerEvents(),
                this.emitEvent("pointerDown", [e, t]));
            }),
            (l.onmousemove = function (e) {
              this.pointerMove(e, e);
            }),
            (l.onpointermove = function (e) {
              this.withPointer("pointerMove", e);
            }),
            (l.ontouchmove = function (e) {
              this.withTouch("pointerMove", e);
            }),
            (l.pointerMove = function (e, t) {
              let i = {
                x: t.pageX - this.pointerDownPointer.pageX,
                y: t.pageY - this.pointerDownPointer.pageY,
              };
              this.emitEvent("pointerMove", [e, t, i]),
                !this.isDragging &&
                  this.hasDragStarted(i) &&
                  this.dragStart(e, t),
                this.isDragging && this.dragMove(e, t, i);
            }),
            (l.hasDragStarted = function (e) {
              return Math.abs(e.x) > 3 || Math.abs(e.y) > 3;
            }),
            (l.dragStart = function (e, t) {
              (this.isDragging = !0),
                (this.isPreventingClicks = !0),
                this.emitEvent("dragStart", [e, t]);
            }),
            (l.dragMove = function (e, t, i) {
              this.emitEvent("dragMove", [e, t, i]);
            }),
            (l.onmouseup = function (e) {
              this.pointerUp(e, e);
            }),
            (l.onpointerup = function (e) {
              this.withPointer("pointerUp", e);
            }),
            (l.ontouchend = function (e) {
              this.withTouch("pointerUp", e);
            }),
            (l.pointerUp = function (e, t) {
              this.pointerDone(),
                this.emitEvent("pointerUp", [e, t]),
                this.isDragging ? this.dragEnd(e, t) : this.staticClick(e, t);
            }),
            (l.dragEnd = function (e, t) {
              (this.isDragging = !1),
                setTimeout(() => delete this.isPreventingClicks),
                this.emitEvent("dragEnd", [e, t]);
            }),
            (l.pointerDone = function () {
              (this.isPointerDown = !1),
                delete this.pointerIdentifier,
                this.unbindActivePointerEvents(),
                this.emitEvent("pointerDone");
            }),
            (l.onpointercancel = function (e) {
              this.withPointer("pointerCancel", e);
            }),
            (l.ontouchcancel = function (e) {
              this.withTouch("pointerCancel", e);
            }),
            (l.pointerCancel = function (e, t) {
              this.pointerDone(), this.emitEvent("pointerCancel", [e, t]);
            }),
            (l.onclick = function (e) {
              this.isPreventingClicks && e.preventDefault();
            }),
            (l.staticClick = function (e, t) {
              let i = "mouseup" === e.type;
              (i && this.isIgnoringMouseUp) ||
                (this.emitEvent("staticClick", [e, t]),
                i &&
                  ((this.isIgnoringMouseUp = !0),
                  setTimeout(() => {
                    delete this.isIgnoringMouseUp;
                  }, 400)));
            }),
            n
          );
        }),
        e.exports
          ? (e.exports = s(i, n("25P9p")))
          : (i.Unidragger = s(i, i.EvEmitter));
    }),
    l("1ZHUF", function (e, t) {
      var i, s;
      (i = "undefined" != typeof window ? window : e.exports),
        (s = function (e) {
          let t = "http://www.w3.org/2000/svg";
          function i(e, t, i) {
            (this.increment = e),
              (this.direction = t),
              (this.isPrevious = "previous" === e),
              (this.isLeft = "left" === t),
              this._create(i);
          }
          (i.prototype._create = function (e) {
            let t = (this.element = document.createElement("button"));
            t.className = `flickity-button flickity-prev-next-button ${this.increment}`;
            let i = this.isPrevious ? "Previous" : "Next";
            t.setAttribute("type", "button"),
              t.setAttribute("aria-label", i),
              this.disable();
            let s = this.createSVG(i, e);
            t.append(s);
          }),
            (i.prototype.createSVG = function (e, i) {
              let s = document.createElementNS(t, "svg");
              s.setAttribute("class", "flickity-button-icon"),
                s.setAttribute("viewBox", "0 0 100 100");
              let n = document.createElementNS(t, "title");
              n.append(e);
              let l = document.createElementNS(t, "path"),
                r = (function (e) {
                  if ("string" == typeof e) return e;
                  let { x0: t, x1: i, x2: s, x3: n, y1: l, y2: r } = e;
                  return `M ${t}, 50
    L ${i}, ${l + 50}
    L ${s}, ${r + 50}
    L ${n}, 50
    L ${s}, ${50 - r}
    L ${i}, ${50 - l}
    Z`;
                })(i);
              return (
                l.setAttribute("d", r),
                l.setAttribute("class", "arrow"),
                this.isLeft ||
                  l.setAttribute(
                    "transform",
                    "translate(100, 100) rotate(180)"
                  ),
                s.append(n, l),
                s
              );
            }),
            (i.prototype.enable = function () {
              this.element.removeAttribute("disabled");
            }),
            (i.prototype.disable = function () {
              this.element.setAttribute("disabled", !0);
            }),
            Object.assign(e.defaults, {
              prevNextButtons: !0,
              arrowShape: { x0: 10, x1: 60, y1: 50, x2: 70, y2: 40, x3: 30 },
            }),
            (e.create.prevNextButtons = function () {
              if (!this.options.prevNextButtons) return;
              let { rightToLeft: e, arrowShape: t } = this.options;
              (this.prevButton = new i("previous", e ? "right" : "left", t)),
                (this.nextButton = new i("next", e ? "left" : "right", t)),
                this.focusableElems.push(this.prevButton.element),
                this.focusableElems.push(this.nextButton.element),
                (this.handlePrevButtonClick = () => {
                  this.uiChange(), this.previous();
                }),
                (this.handleNextButtonClick = () => {
                  this.uiChange(), this.next();
                }),
                this.on("activate", this.activatePrevNextButtons),
                this.on("select", this.updatePrevNextButtons);
            });
          let s = e.prototype;
          return (
            (s.updatePrevNextButtons = function () {
              let e = this.slides.length ? this.slides.length - 1 : 0;
              this.updatePrevNextButton(this.prevButton, 0),
                this.updatePrevNextButton(this.nextButton, e);
            }),
            (s.updatePrevNextButton = function (e, t) {
              if (this.isWrapping && this.slides.length > 1) {
                e.enable();
                return;
              }
              let i = this.selectedIndex !== t;
              e[i ? "enable" : "disable"](),
                i || document.activeElement !== e.element || this.focus();
            }),
            (s.activatePrevNextButtons = function () {
              this.prevButton.element.addEventListener(
                "click",
                this.handlePrevButtonClick
              ),
                this.nextButton.element.addEventListener(
                  "click",
                  this.handleNextButtonClick
                ),
                this.element.append(
                  this.prevButton.element,
                  this.nextButton.element
                ),
                this.on("deactivate", this.deactivatePrevNextButtons);
            }),
            (s.deactivatePrevNextButtons = function () {
              this.prevButton.element.remove(),
                this.nextButton.element.remove(),
                this.prevButton.element.removeEventListener(
                  "click",
                  this.handlePrevButtonClick
                ),
                this.nextButton.element.removeEventListener(
                  "click",
                  this.handleNextButtonClick
                ),
                this.off("deactivate", this.deactivatePrevNextButtons);
            }),
            (e.PrevNextButton = i),
            e
          );
        }),
        e.exports ? (e.exports = s(n("gTegW"))) : s(i.Flickity);
    }),
    l("fVgo0", function (e, t) {
      var i, s;
      (i = "undefined" != typeof window ? window : e.exports),
        (s = function (e, t) {
          function i() {
            (this.holder = document.createElement("div")),
              (this.holder.className = "flickity-page-dots"),
              (this.dots = []);
          }
          (i.prototype.setDots = function (e) {
            let t = e - this.dots.length;
            t > 0 ? this.addDots(t) : t < 0 && this.removeDots(-t);
          }),
            (i.prototype.addDots = function (e) {
              let t = Array(e)
                .fill()
                .map((e, t) => {
                  let i = document.createElement("button");
                  i.setAttribute("type", "button");
                  let s = t + 1 + this.dots.length;
                  return (
                    (i.className = "flickity-page-dot"),
                    (i.textContent = `View slide ${s}`),
                    i
                  );
                });
              this.holder.append(...t), (this.dots = this.dots.concat(t));
            }),
            (i.prototype.removeDots = function (e) {
              this.dots
                .splice(this.dots.length - e, e)
                .forEach((e) => e.remove());
            }),
            (i.prototype.updateSelected = function (e) {
              this.selectedDot &&
                (this.selectedDot.classList.remove("is-selected"),
                this.selectedDot.removeAttribute("aria-current")),
                this.dots.length &&
                  ((this.selectedDot = this.dots[e]),
                  this.selectedDot.classList.add("is-selected"),
                  this.selectedDot.setAttribute("aria-current", "step"));
            }),
            (e.PageDots = i),
            Object.assign(e.defaults, { pageDots: !0 }),
            (e.create.pageDots = function () {
              this.options.pageDots &&
                ((this.pageDots = new i()),
                (this.handlePageDotsClick = this.onPageDotsClick.bind(this)),
                this.on("activate", this.activatePageDots),
                this.on("select", this.updateSelectedPageDots),
                this.on("cellChange", this.updatePageDots),
                this.on("resize", this.updatePageDots),
                this.on("deactivate", this.deactivatePageDots));
            });
          let s = e.prototype;
          return (
            (s.activatePageDots = function () {
              this.pageDots.setDots(this.slides.length),
                this.focusableElems.push(...this.pageDots.dots),
                this.pageDots.holder.addEventListener(
                  "click",
                  this.handlePageDotsClick
                ),
                this.element.append(this.pageDots.holder);
            }),
            (s.onPageDotsClick = function (e) {
              let t = this.pageDots.dots.indexOf(e.target);
              -1 !== t && (this.uiChange(), this.select(t));
            }),
            (s.updateSelectedPageDots = function () {
              this.pageDots.updateSelected(this.selectedIndex);
            }),
            (s.updatePageDots = function () {
              this.pageDots.dots.forEach((e) => {
                t.removeFrom(this.focusableElems, e);
              }),
                this.pageDots.setDots(this.slides.length),
                this.focusableElems.push(...this.pageDots.dots);
            }),
            (s.deactivatePageDots = function () {
              this.pageDots.holder.remove(),
                this.pageDots.holder.removeEventListener(
                  "click",
                  this.handlePageDotsClick
                );
            }),
            (e.PageDots = i),
            e
          );
        }),
        e.exports
          ? (e.exports = s(n("gTegW"), n("aWUGO")))
          : s(i.Flickity, i.fizzyUIUtils);
    }),
    l("bg0PD", function (e, t) {
      var i, s;
      (i = "undefined" != typeof window ? window : e.exports),
        (s = function (e) {
          function t(e, t) {
            (this.autoPlay = e),
              (this.onTick = t),
              (this.state = "stopped"),
              (this.onVisibilityChange = this.visibilityChange.bind(this)),
              (this.onVisibilityPlay = this.visibilityPlay.bind(this));
          }
          (t.prototype.play = function () {
            if ("playing" !== this.state) {
              if (document.hidden) {
                document.addEventListener(
                  "visibilitychange",
                  this.onVisibilityPlay
                );
                return;
              }
              (this.state = "playing"),
                document.addEventListener(
                  "visibilitychange",
                  this.onVisibilityChange
                ),
                this.tick();
            }
          }),
            (t.prototype.tick = function () {
              if ("playing" !== this.state) return;
              let e = "number" == typeof this.autoPlay ? this.autoPlay : 3e3;
              this.clear(),
                (this.timeout = setTimeout(() => {
                  this.onTick(), this.tick();
                }, e));
            }),
            (t.prototype.stop = function () {
              (this.state = "stopped"),
                this.clear(),
                document.removeEventListener(
                  "visibilitychange",
                  this.onVisibilityChange
                );
            }),
            (t.prototype.clear = function () {
              clearTimeout(this.timeout);
            }),
            (t.prototype.pause = function () {
              "playing" === this.state &&
                ((this.state = "paused"), this.clear());
            }),
            (t.prototype.unpause = function () {
              "paused" === this.state && this.play();
            }),
            (t.prototype.visibilityChange = function () {
              this[document.hidden ? "pause" : "unpause"]();
            }),
            (t.prototype.visibilityPlay = function () {
              this.play(),
                document.removeEventListener(
                  "visibilitychange",
                  this.onVisibilityPlay
                );
            }),
            Object.assign(e.defaults, { pauseAutoPlayOnHover: !0 }),
            (e.create.player = function () {
              (this.player = new t(this.options.autoPlay, () => {
                this.next(!0);
              })),
                this.on("activate", this.activatePlayer),
                this.on("uiChange", this.stopPlayer),
                this.on("pointerDown", this.stopPlayer),
                this.on("deactivate", this.deactivatePlayer);
            });
          let i = e.prototype;
          return (
            (i.activatePlayer = function () {
              this.options.autoPlay &&
                (this.player.play(),
                this.element.addEventListener("mouseenter", this));
            }),
            (i.playPlayer = function () {
              this.player.play();
            }),
            (i.stopPlayer = function () {
              this.player.stop();
            }),
            (i.pausePlayer = function () {
              this.player.pause();
            }),
            (i.unpausePlayer = function () {
              this.player.unpause();
            }),
            (i.deactivatePlayer = function () {
              this.player.stop(),
                this.element.removeEventListener("mouseenter", this);
            }),
            (i.onmouseenter = function () {
              this.options.pauseAutoPlayOnHover &&
                (this.player.pause(),
                this.element.addEventListener("mouseleave", this));
            }),
            (i.onmouseleave = function () {
              this.player.unpause(),
                this.element.removeEventListener("mouseleave", this);
            }),
            (e.Player = t),
            e
          );
        }),
        e.exports ? (e.exports = s(n("gTegW"))) : s(i.Flickity);
    }),
    l("b73Pg", function (e, t) {
      var i, s;
      (i = "undefined" != typeof window ? window : e.exports),
        (s = function (e, t) {
          let i = e.prototype;
          return (
            (i.insert = function (e, t) {
              let i,
                s = this._makeCells(e);
              if (!s || !s.length) return;
              let n = this.cells.length;
              t = void 0 === t ? n : t;
              let l =
                  ((i = document.createDocumentFragment()),
                  s.forEach((e) => i.appendChild(e.element)),
                  i),
                r = t === n;
              if (r) this.slider.appendChild(l);
              else {
                let e = this.cells[t].element;
                this.slider.insertBefore(l, e);
              }
              if (0 === t) this.cells = s.concat(this.cells);
              else if (r) this.cells = this.cells.concat(s);
              else {
                let e = this.cells.splice(t, n - t);
                this.cells = this.cells.concat(s).concat(e);
              }
              this._sizeCells(s),
                this.cellChange(t),
                this.positionSliderAtSelected();
            }),
            (i.append = function (e) {
              this.insert(e, this.cells.length);
            }),
            (i.prepend = function (e) {
              this.insert(e, 0);
            }),
            (i.remove = function (e) {
              let i = this.getCells(e);
              if (!i || !i.length) return;
              let s = this.cells.length - 1;
              i.forEach((e) => {
                e.remove(),
                  (s = Math.min(this.cells.indexOf(e), s)),
                  t.removeFrom(this.cells, e);
              }),
                this.cellChange(s),
                this.positionSliderAtSelected();
            }),
            (i.cellSizeChange = function (e) {
              let t = this.getCell(e);
              if (!t) return;
              t.getSize();
              let i = this.cells.indexOf(t);
              this.cellChange(i);
            }),
            (i.cellChange = function (e) {
              let t = this.selectedElement;
              this._positionCells(e),
                this._updateWrapShiftCells(),
                this.setGallerySize();
              let i = this.getCell(t);
              i && (this.selectedIndex = this.getCellSlideIndex(i)),
                (this.selectedIndex = Math.min(
                  this.slides.length - 1,
                  this.selectedIndex
                )),
                this.emitEvent("cellChange", [e]),
                this.select(this.selectedIndex);
            }),
            e
          );
        }),
        e.exports
          ? (e.exports = s(n("gTegW"), n("aWUGO")))
          : s(i.Flickity, i.fizzyUIUtils);
    }),
    l("jucDH", function (e, t) {
      var i, s;
      (i = "undefined" != typeof window ? window : e.exports),
        (s = function (e, t) {
          let i = "data-flickity-lazyload",
            s = `${i}-src`,
            n = `${i}-srcset`,
            l = `img[${i}], img[${s}], img[${n}], source[${n}]`;
          e.create.lazyLoad = function () {
            this.on("select", this.lazyLoad),
              (this.handleLazyLoadComplete =
                this.onLazyLoadComplete.bind(this));
          };
          let r = e.prototype;
          function o(e) {
            if (e.matches("img")) {
              let t = e.getAttribute(i),
                l = e.getAttribute(s),
                r = e.getAttribute(n);
              if (t || l || r) return e;
            }
            return [...e.querySelectorAll(l)];
          }
          function a(e, t) {
            (this.img = e), (this.onComplete = t), this.load();
          }
          return (
            (r.lazyLoad = function () {
              let { lazyLoad: e } = this.options;
              e &&
                this.getAdjacentCellElements("number" == typeof e ? e : 0)
                  .map(o)
                  .flat()
                  .forEach((e) => new a(e, this.handleLazyLoadComplete));
            }),
            (r.onLazyLoadComplete = function (e, t) {
              let i = this.getParentCell(e),
                s = i && i.element;
              this.cellSizeChange(s), this.dispatchEvent("lazyLoad", t, s);
            }),
            (a.prototype.handleEvent = t.handleEvent),
            (a.prototype.load = function () {
              this.img.addEventListener("load", this),
                this.img.addEventListener("error", this);
              let e = this.img.getAttribute(i) || this.img.getAttribute(s),
                t = this.img.getAttribute(n);
              (this.img.src = e),
                t && this.img.setAttribute("srcset", t),
                this.img.removeAttribute(i),
                this.img.removeAttribute(s),
                this.img.removeAttribute(n);
            }),
            (a.prototype.onload = function (e) {
              this.complete(e, "flickity-lazyloaded");
            }),
            (a.prototype.onerror = function (e) {
              this.complete(e, "flickity-lazyerror");
            }),
            (a.prototype.complete = function (e, t) {
              this.img.removeEventListener("load", this),
                this.img.removeEventListener("error", this),
                (this.img.parentNode.matches("picture")
                  ? this.img.parentNode
                  : this.img
                ).classList.add(t),
                this.onComplete(this.img, e);
            }),
            (e.LazyLoader = a),
            e
          );
        }),
        e.exports
          ? (e.exports = s(n("gTegW"), n("aWUGO")))
          : s(i.Flickity, i.fizzyUIUtils);
    }),
    l("3JjaQ", function (e, t) {
      var i, s;
      (i = "undefined" != typeof window ? window : e.exports),
        (s = function (e, t) {
          return (
            (e.create.imagesLoaded = function () {
              this.on("activate", this.imagesLoaded);
            }),
            (e.prototype.imagesLoaded = function () {
              this.options.imagesLoaded &&
                t(this.slider).on("progress", (e, t) => {
                  let i = this.getParentCell(t.img);
                  this.cellSizeChange(i && i.element),
                    this.options.freeScroll || this.positionSliderAtSelected();
                });
            }),
            e
          );
        }),
        e.exports
          ? (e.exports = s(n("gTegW"), n("eyNow")))
          : s(i.Flickity, i.imagesLoaded);
    }),
    l("eyNow", function (e, t) {
      var i, s;
      (i = "undefined" != typeof window ? window : e.exports),
        (s = function (e, t) {
          let i = e.jQuery,
            s = e.console;
          function n(e, t, l) {
            var r;
            if (!(this instanceof n)) return new n(e, t, l);
            let o = e;
            if (
              ("string" == typeof e && (o = document.querySelectorAll(e)), !o)
            ) {
              s.error(`Bad element for imagesLoaded ${o || e}`);
              return;
            }
            (this.elements = Array.isArray((r = o))
              ? r
              : "object" == typeof r && "number" == typeof r.length
              ? [...r]
              : [r]),
              (this.options = {}),
              "function" == typeof t ? (l = t) : Object.assign(this.options, t),
              l && this.on("always", l),
              this.getImages(),
              i && (this.jqDeferred = new i.Deferred()),
              setTimeout(this.check.bind(this));
          }
          (n.prototype = Object.create(t.prototype)),
            (n.prototype.getImages = function () {
              (this.images = []),
                this.elements.forEach(this.addElementImages, this);
            });
          let l = [1, 9, 11];
          n.prototype.addElementImages = function (e) {
            "IMG" === e.nodeName && this.addImage(e),
              !0 === this.options.background &&
                this.addElementBackgroundImages(e);
            let { nodeType: t } = e;
            if (t && l.includes(t)) {
              for (let t of e.querySelectorAll("img")) this.addImage(t);
              if ("string" == typeof this.options.background)
                for (let t of e.querySelectorAll(this.options.background))
                  this.addElementBackgroundImages(t);
            }
          };
          let r = /url\((['"])?(.*?)\1\)/gi;
          function o(e) {
            this.img = e;
          }
          function a(e, t) {
            (this.url = e), (this.element = t), (this.img = new Image());
          }
          return (
            (n.prototype.addElementBackgroundImages = function (e) {
              let t = getComputedStyle(e);
              if (!t) return;
              let i = r.exec(t.backgroundImage);
              for (; null !== i; ) {
                let s = i && i[2];
                s && this.addBackground(s, e), (i = r.exec(t.backgroundImage));
              }
            }),
            (n.prototype.addImage = function (e) {
              let t = new o(e);
              this.images.push(t);
            }),
            (n.prototype.addBackground = function (e, t) {
              let i = new a(e, t);
              this.images.push(i);
            }),
            (n.prototype.check = function () {
              if (
                ((this.progressedCount = 0),
                (this.hasAnyBroken = !1),
                !this.images.length)
              ) {
                this.complete();
                return;
              }
              let e = (e, t, i) => {
                setTimeout(() => {
                  this.progress(e, t, i);
                });
              };
              this.images.forEach(function (t) {
                t.once("progress", e), t.check();
              });
            }),
            (n.prototype.progress = function (e, t, i) {
              this.progressedCount++,
                (this.hasAnyBroken = this.hasAnyBroken || !e.isLoaded),
                this.emitEvent("progress", [this, e, t]),
                this.jqDeferred &&
                  this.jqDeferred.notify &&
                  this.jqDeferred.notify(this, e),
                this.progressedCount === this.images.length && this.complete(),
                this.options.debug && s && s.log(`progress: ${i}`, e, t);
            }),
            (n.prototype.complete = function () {
              let e = this.hasAnyBroken ? "fail" : "done";
              if (
                ((this.isComplete = !0),
                this.emitEvent(e, [this]),
                this.emitEvent("always", [this]),
                this.jqDeferred)
              ) {
                let e = this.hasAnyBroken ? "reject" : "resolve";
                this.jqDeferred[e](this);
              }
            }),
            (o.prototype = Object.create(t.prototype)),
            (o.prototype.check = function () {
              if (this.getIsImageComplete()) {
                this.confirm(0 !== this.img.naturalWidth, "naturalWidth");
                return;
              }
              (this.proxyImage = new Image()),
                this.img.crossOrigin &&
                  (this.proxyImage.crossOrigin = this.img.crossOrigin),
                this.proxyImage.addEventListener("load", this),
                this.proxyImage.addEventListener("error", this),
                this.img.addEventListener("load", this),
                this.img.addEventListener("error", this),
                (this.proxyImage.src = this.img.currentSrc || this.img.src);
            }),
            (o.prototype.getIsImageComplete = function () {
              return this.img.complete && this.img.naturalWidth;
            }),
            (o.prototype.confirm = function (e, t) {
              this.isLoaded = e;
              let { parentNode: i } = this.img,
                s = "PICTURE" === i.nodeName ? i : this.img;
              this.emitEvent("progress", [this, s, t]);
            }),
            (o.prototype.handleEvent = function (e) {
              let t = "on" + e.type;
              this[t] && this[t](e);
            }),
            (o.prototype.onload = function () {
              this.confirm(!0, "onload"), this.unbindEvents();
            }),
            (o.prototype.onerror = function () {
              this.confirm(!1, "onerror"), this.unbindEvents();
            }),
            (o.prototype.unbindEvents = function () {
              this.proxyImage.removeEventListener("load", this),
                this.proxyImage.removeEventListener("error", this),
                this.img.removeEventListener("load", this),
                this.img.removeEventListener("error", this);
            }),
            (a.prototype = Object.create(o.prototype)),
            (a.prototype.check = function () {
              this.img.addEventListener("load", this),
                this.img.addEventListener("error", this),
                (this.img.src = this.url),
                this.getIsImageComplete() &&
                  (this.confirm(0 !== this.img.naturalWidth, "naturalWidth"),
                  this.unbindEvents());
            }),
            (a.prototype.unbindEvents = function () {
              this.img.removeEventListener("load", this),
                this.img.removeEventListener("error", this);
            }),
            (a.prototype.confirm = function (e, t) {
              (this.isLoaded = e),
                this.emitEvent("progress", [this, this.element, t]);
            }),
            (n.makeJQueryPlugin = function (t) {
              (t = t || e.jQuery) &&
                ((i = t).fn.imagesLoaded = function (e, t) {
                  return new n(this, e, t).jqDeferred.promise(i(this));
                });
            }),
            n.makeJQueryPlugin(),
            n
          );
        }),
        e.exports
          ? (e.exports = s(i, n("25P9p")))
          : (i.imagesLoaded = s(i, i.EvEmitter));
    });
  let r = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
    }),
    o = async (e, t, i) => {
      let s = await fetch(t, {
        method: e,
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(i),
      });
      if (!s.ok) throw Error(JSON.parse(await s.text()).description);
      let n = await s.text();
      return n ? JSON.parse(n) : {};
    };
  function a(e, t = inputDelay) {
    let i;
    return (...s) => {
      clearTimeout(i),
        (i = setTimeout(() => {
          e.apply(this, s);
        }, t));
    };
  }
  function c(e, t) {
    return e
      .replace(
        /_(pico|icon|thumb|small|compact|medium|large|grande|original|1024x1024|2048x2048|master)+\./g,
        "."
      )
      .replace(/\.jpg|\.png|\.gif|\.jpeg/g, function (e) {
        return "_" + t + e;
      });
  }
  var d = {};
  /*!
   * Flickity v3.0.0
   * Touch, responsive, flickable carousels
   *
   * Licensed GPLv3 for open source use
   * (or) Flickity Commercial License for commercial use
   *
   * https://flickity.metafizzy.co
   * Copyright 2015-2022 Metafizzy
   */ if (d) {
    let e = n("gTegW");
    n("iy2JW"),
      n("1ZHUF"),
      n("fVgo0"),
      n("bg0PD"),
      n("b73Pg"),
      n("jucDH"),
      n("3JjaQ"),
      (d = e);
  }
  function u() {
    document.querySelectorAll(".lsg-meganav").forEach((e) => {
      let t = e.querySelector("[lsg-meganav-btn-mobile]"),
        i = e.querySelector("[lsg-subnav-groups]"),
        s = e.querySelectorAll("[lsg-subnav-btn-mobile]"),
        n = e.querySelectorAll("[lsg-subnav-group]");
      e.setAttribute("aria-hidden", !0),
        e.classList.remove("lsg-meganav-active"),
        t && t.classList.remove("lsg-meganav-btn-mobile-active"),
        i && i.classList.remove("lsg-subnav-groups-active"),
        s.forEach((e) => {
          e.classList.remove("lsg-subnav-btn-active");
        }),
        n.forEach((e) => {
          e.classList.remove("lsg-subnav-group-active-mobile");
        });
    });
  }
  function h(e) {
    let t = document.querySelector(`.lsg-meganav[lsg-meganav-handle="${e}"]`);
    if (t) {
      let i = document.getElementById("lsg-header-group"),
        s = document.getElementById("lsg-meganav-group"),
        n = document.querySelector(
          `[lsg-meganav-btn][lsg-meganav-handle="${e}"]`
        ),
        l = document.querySelector(
          `[lsg-meganav-link][lsg-meganav-handle="${e}"]`
        ),
        r = t.querySelector(".lsg-subnav-btn-active");
      u(),
        i.classList.add("lsg-meganav-open"),
        t.classList.add("lsg-meganav-active"),
        t.setAttribute("aria-hidden", !1),
        s.classList.add("lsg-meganav-group-active"),
        n.classList.add("lsg-meganav-btn-active"),
        n.setAttribute("aria-expanded", !0),
        l.classList.add("lsg-meganav-link-active"),
        r && r.focus();
    } else
      console.error(
        `No LSG MegaNav with the handle '${e}' was found, please check your settings.`
      );
  }
  function g(e) {
    let t = document.querySelector(`.lsg-meganav[lsg-meganav-handle="${e}"]`);
    if (t) {
      let i = document.getElementById("lsg-header-group"),
        s = document.querySelector(
          `[lsg-meganav-btn][lsg-meganav-handle="${e}"]`
        ),
        n = document.querySelector(
          `[lsg-meganav-link][lsg-meganav-handle="${e}"]`
        );
      i.classList.remove("lsg-meganav-open"),
        t.classList.remove("lsg-meganav-active"),
        t.setAttribute("aria-hidden", !0),
        s.classList.remove("lsg-meganav-btn-active"),
        s.setAttribute("aria-expanded", !1),
        n.classList.remove("lsg-meganav-link-active");
    } else
      console.error(
        `No LSG MegaNav with the handle '${e}' was found, please check your settings.`
      );
  }
  function p(e) {
    let t = document.getElementById("lsg-meganav-group"),
      i = e.querySelector("[lsg-mobile-menu-btn]"),
      s = document.querySelectorAll(".lsg-meganav");
    i.classList.add("lsg-mobile-menu-btn-active"),
      s.forEach((e) => {
        e.classList.add("lsg-meganav-mobile-active");
      }),
      t.classList.add("lsg-meganav-group-active"),
      t.classList.add("lsg-meganav-group-mobile-active"),
      document.body.classList.add("is-locked");
  }
  function m(e) {
    let t = document.getElementById("lsg-meganav-group"),
      i = e.querySelector("[lsg-mobile-menu-btn]"),
      s = document.querySelectorAll(".lsg-meganav");
    i.classList.remove("lsg-mobile-menu-btn-active"),
      s.forEach((e) => {
        e.classList.remove("lsg-meganav-mobile-active");
      }),
      t.classList.remove("lsg-meganav-group-active"),
      t.classList.remove("lsg-meganav-group-mobile-active"),
      document.body.classList.remove("is-locked"),
      u();
  }
  let f = document.querySelectorAll("[lsg-accordion-item]");
  function v(e) {
    if (e && "true" !== e.getAttribute("lsg-transitioning")) {
      e.setAttribute("lsg-transitioning", !0);
      let t = e.scrollHeight,
        i = e.style.transition;
      (e.style.transition = ""),
        requestAnimationFrame(function () {
          (e.style.height = t + "px"),
            (e.style.transition = i),
            requestAnimationFrame(function () {
              (e.style.height = "0px"), e.setAttribute("lsg-transitioning", !1);
            });
        });
    }
  }
  f.forEach((e) => {
    let t = e.querySelector("[lsg-accordion-item-btn]"),
      i = e.querySelector("[lsg-accordion-item-content]"),
      s = e.querySelector('input[type="radio"]');
    s
      ? !0 == !s.checked && (e.setAttribute("aria-expanded", !1), v(i))
      : "true" !== e.getAttribute("lsg-accordion-item-start-open") &&
        (e.setAttribute("aria-expanded", !1), v(i)),
      t.addEventListener("click", (t) => {
        if (i && "true" !== i.getAttribute("lsg-transitioning")) {
          let t = e.getAttribute("aria-expanded");
          e.parentElement
            .querySelectorAll("[lsg-accordion-item]")
            .forEach((t) => {
              if (t !== e && "true" === t.getAttribute("aria-expanded")) {
                let e = t.querySelector("[lsg-accordion-item-content]");
                t.setAttribute("aria-expanded", !1), v(e);
              }
            }),
            "true" === t
              ? (e.setAttribute("aria-expanded", !1), v(i))
              : (e.setAttribute("aria-expanded", !0),
                (function (e) {
                  if (e && "true" !== e.getAttribute("lsg-transitioning")) {
                    e.setAttribute("lsg-transitioning", !0);
                    let t = e.scrollHeight;
                    e.style.height = t + "px";
                    let i = function (t) {
                      e.removeEventListener("transitionend", i),
                        (e.style.height = null),
                        e.scrollHeight,
                        e.setAttribute("lsg-transitioning", !1);
                    };
                    e.addEventListener("transitionend", i);
                  }
                })(i));
        } else
          f.forEach((t) => {
            if (t !== e && "true" === t.getAttribute("aria-expanded")) {
              let e = t.querySelector("[lsg-accordion-item-content]");
              t.setAttribute("aria-expanded", !1), v(e);
            }
          });
      });
  });
  let y = document.querySelectorAll("[lsg-recommendations]"),
    b = `${window.Shopify.routes.root}recommendations/products.json`;
  async function E(t, i) {
    let s = `product_id=${t}`,
      n = `limit=${i.getAttribute("lsg-recommendations-limit")}`,
      l = `intent=${i.getAttribute("lsg-recommendations-intent")}`,
      a = await o("GET", `${b}?${s}&${n}&${l}`),
      u = [];
    a.products.forEach((e) => {
      let t = `/products/${e.handle}?view=lsg-metafields`;
      u.push(
        o("GET", t).then((t) => {
          e.metafields = t;
        })
      );
    }),
      Promise.all(u).then(() => {
        let t = [];
        a.products.forEach((e) => {
          void 0 !== e.metafields.upsell_exclude
            ? e.metafields.upsell_exclude
            : t.push(e);
        }),
          (function (t, i) {
            let s = i.getAttribute("data-block-id"),
              n = JSON.parse(
                document.getElementById(`CarouselSettings-${s}`).textContent
              ),
              l = i.querySelector(".lsg-mini-upsell-carousel__wrapper");
            n.imagesLoaded = !0;
            let r = /*@__PURE__*/ e(d).data(l);
            if (void 0 !== r) {
              let e = r.cells,
                s = [];
              e.forEach((e) => {
                s.push(e.element);
              }),
                r.remove(s),
                t.length < 1
                  ? (r.destroy(),
                    i.classList.add("lsg-mini-upsell-carousel-inactive"))
                  : (r.append(t), r.select(0, !1, !0));
            } else
              t.length > 0
                ? (t.forEach((e) => {
                    l.appendChild(e);
                  }),
                  i.classList.remove("lsg-mini-upsell-carousel-inactive"),
                  (r = new /*@__PURE__*/ (e(d))(l, n)))
                : i.classList.add("lsg-mini-upsell-carousel-inactive");
          })(
            (function (e, t) {
              let i = t.getAttribute("data-block-id"),
                s = t.getAttribute("lsg-recommendations-truncate"),
                n = t.getAttribute("[lsg-recommendations-controls-class]"),
                l = document.querySelector(`template[data-block-id="${i}"]`),
                o = [];
              return (
                e.forEach((e) => {
                  let t, i;
                  let a = l.content.firstElementChild.cloneNode(!0),
                    d = a.querySelector("img"),
                    u = a.querySelector(
                      ".lsg-mini-upsell-carousel-slide__title-group"
                    ),
                    h = a.querySelector(
                      ".lsg-mini-upsell-carousel-slide__title"
                    ),
                    g = a.querySelector(
                      ".lsg-mini-upsell-carousel-slide__price"
                    ),
                    p = a.querySelector(".shopify-product-form");
                  if (void 0 !== e.metafields.upsell_title_override)
                    t = e.metafields.upsell_title_override;
                  else if ("true" === s) {
                    var m;
                    t = (m = e.title).length <= 20 ? m : m.slice(0, 20) + "...";
                  } else t = e.title;
                  if (void 0 !== e.metafields.upsell_notice) {
                    let t = document.createElement("div");
                    (t.textContent = e.metafields.upsell_notice),
                      t.classList.add("lsg-caption"),
                      t.classList.add("lsg-mini-upsell-carousel-slide__notice"),
                      u.appendChild(t);
                  }
                  if (
                    e.compare_at_price &&
                    e.compare_at_price !== e.price &&
                    0 !== e.compare_at_price
                  ) {
                    let t = `<span style="text-decoration: line-through;">${r.format(
                        e.compare_at_price / 100
                      )}</span>`,
                      s = `<strong>${r.format(e.price / 100)}</strong>`;
                    i = `${t} - ${s}`;
                  } else i = r.format(e.price / 100);
                  (d.src = c(e.media[0].src, "medium")),
                    (h.innerHTML = t),
                    (g.innerHTML = i),
                    p.setAttribute("id", `product_form_${e.id}`),
                    p.setAttribute("data-productid", e.id);
                  let f = [];
                  if (
                    (e.variants.forEach((t) => {
                      let i = e.metafields.variants.find(
                        (e) => e.id === parseInt(t.id)
                      ).selling_plan_only;
                      (void 0 === i || !1 === i) && f.push(t);
                    }),
                    1 === f.length)
                  ) {
                    let t = document.createElement("input");
                    t.setAttribute("type", "hidden"),
                      t.setAttribute("name", "id"),
                      t.setAttribute("value", e.variants[0].id),
                      p.appendChild(t);
                    let i = document.createElement("button");
                    i.setAttribute("type", "submit"),
                      i.classList.add("lsg-button", "lsg-button__style-1", n),
                      (i.textContent = "+ Add"),
                      p.appendChild(i);
                  } else {
                    let t = document.createElement("div");
                    t.classList.add("lsg-select-wrapper");
                    let i = document.createElement("select");
                    i.setAttribute("name", "id"),
                      i.setAttribute("id", `productSelect-${e.id}`),
                      t.appendChild(i);
                    let s = document.createElement("option");
                    (s.textContent = "SELECT AN OPTION"),
                      i.appendChild(s),
                      f.forEach((e) => {
                        let t;
                        let s = document.createElement("option");
                        s.setAttribute("value", e.id),
                          e.available
                            ? (t = `${e.title} - ${r.format(e.price / 100)}`)
                            : (s.setAttribute("disabled", !0),
                              (t = `${e.title} - Sold Out`)),
                          (s.textContent = t),
                          i.appendChild(s);
                      }),
                      p.appendChild(t);
                  }
                  if (
                    void 0 !== e.metafields.upsell_as_subscription &&
                    e.metafields.upsell_as_subscription
                  ) {
                    let t = document.createElement("input");
                    t.setAttribute("type", "hidden"),
                      t.setAttribute("name", "selling_plan"),
                      e.variants[0].selling_plan_allocations.find((i) => {
                        let s = e.selling_plan_groups.find(
                            (e) => e.id === i.selling_plan_group_id
                          ),
                          n = s.selling_plans.find(
                            (e) => e.id === parseInt(i.selling_plan_id)
                          );
                        if (
                          parseInt(s.app_id) ===
                          e.metafields.subscription_app_id
                        )
                          return t.setAttribute("value", n.id), !0;
                      }),
                      p.appendChild(t);
                  }
                  p.addEventListener("submit", (e) => {
                    e.preventDefault(), k(new FormData(e.target), p);
                  });
                  let v = p.querySelector("select");
                  v &&
                    v.addEventListener("change", (t) => {
                      let i = v.value,
                        s = e.variants.find((e) => e.id === parseInt(i)),
                        n = v
                          .closest("form")
                          .querySelector('input[name="selling_plan"]');
                      s.selling_plan_allocations.find((t) => {
                        let i = e.selling_plan_groups.find(
                            (e) => e.id === t.selling_plan_group_id
                          ),
                          s = i.selling_plans.find(
                            (e) => e.id === parseInt(t.selling_plan_id)
                          );
                        if (
                          parseInt(i.app_id) ===
                          e.metafields.subscription_app_id
                        )
                          return n.setAttribute("value", s.id), !0;
                      }),
                        "SELECT AN OPTION" !== v.value && p.requestSubmit();
                    }),
                    o.push(a);
                }),
                o
              );
            })(t, i),
            i
          );
      });
  }
  y.forEach((e) => {
    E(e.getAttribute("lsg-recommendations-product-id"), e);
  });
  let S = document.querySelector("[lsg-cart-handler]"),
    q = window.Shopify.routes.root + "cart.js",
    L = window.Shopify.routes.root + "cart/add.js",
    _ =
      (window.Shopify.routes.root,
      window.Shopify.routes.root,
      window.Shopify.routes.root + "cart/change.js"),
    A = S.classList.contains("lsg-slidecart-rebuild");
  S.classList.add("lsg-cart-handler-active");
  let x = S.querySelector("[lsg-cart-product-list]");
  function w(e) {
    let t = { id: e.getAttribute("lsg-cart-line-item") },
      i = e.querySelector("[lsg-cart-qty-minus]"),
      s = e.querySelector("[lsg-cart-qty-plus]");
    i.addEventListener(
      "click",
      a(
        (i) =>
          (function (e, t) {
            let i = e.querySelector("[lsg-cart-qty-input]"),
              s = parseInt(i.value);
            (t.quantity = s - 1),
              o("POST", _, t)
                .then((s) => {
                  let n = s.items.find((e) => e.key === t.id);
                  void 0 === n
                    ? e.remove()
                    : i.setAttribute("value", n.quantity),
                    P();
                })
                .catch((t) => {
                  C(e, t);
                });
          })(e, t),
        150
      )
    ),
      s.addEventListener(
        "click",
        a(
          (i) =>
            (function (e, t) {
              let i;
              let s = e.querySelector("[lsg-cart-qty-input]"),
                n = parseInt(s.getAttribute("max")),
                l = parseInt(s.value);
              l !== n &&
                ((i = l > n ? n : l + 1),
                (t.quantity = i),
                o("POST", _, t)
                  .then((e) => {
                    let i = e.items.find((e) => e.key === t.id);
                    s.setAttribute("value", i.quantity), P();
                  })
                  .catch((t) => {
                    C(e, t);
                  }));
            })(e, t),
          150
        )
      );
    let n = e.querySelector("[lsg-cart-remove]");
    n?.addEventListener("click", (i) => {
      i.preventDefault(),
        (t.quantity = 0),
        o("POST", _, t)
          .then((t) => {
            e.remove(), P();
          })
          .catch((t) => {
            C(e, t);
          });
    });
    let l = e.querySelector("[lsg-cart-selling-plan-btn]"),
      r = e.querySelector("[lsg-cart-selling-plan-select]");
    l?.addEventListener("click", (t) =>
      (function (e, t) {
        let i = t.getAttribute("lsg-cart-line-item"),
          s = t.querySelector("[lsg-cart-frequency-group]"),
          n = t.querySelector("[lsg-cart-selling-plan-select]"),
          l = n.querySelector("[lsg-cart-first-selling-plan]").value,
          r = {
            id: i,
            quantity: t.querySelector("[lsg-cart-qty-input]").value,
          };
        (r.selling_plan = l),
          o("POST", _, r)
            .then((e) => {
              (n.value = l),
                s.classList.add("lsg-cart-line-item__frequency-has-spa"),
                P();
            })
            .catch((e) => {
              C(t, e);
            });
      })(0, e)
    ),
      r?.addEventListener("change", (t) =>
        (function (e, t) {
          let i = t.getAttribute("lsg-cart-line-item"),
            s = t.querySelector("[lsg-cart-frequency-group]"),
            n = e.target.value,
            l = parseInt(
              e.target.options[e.target.selectedIndex].getAttribute(
                "lsg-cart-freq-variant"
              )
            ),
            r = parseInt(
              e.target.options[e.target.selectedIndex].getAttribute(
                "lsg-cart-freq-add-variant"
              )
            ),
            a = t.querySelector("[lsg-cart-qty-input]").value,
            c = parseInt(i.split(":")[0]);
          if (isNaN(l) && !isNaN(r))
            o("POST", L, {
              items: [{ id: r, quantity: 1, properties: { _added_item: !0 } }],
            })
              .then((e) => {
                t.remove(),
                  e.items.forEach((e) => {
                    S.querySelector(`[lsg-cart-line-item="${e.key}"]`)
                      ? (A && window.LSG_OPEN_CART(), P())
                      : D(e);
                  });
              })
              .catch((e) => {
                console.error(e), alert(e);
              });
          else if (l !== c) {
            let e = { items: [{ id: l, quantity: a, selling_plan: n }] };
            o("POST", _, { id: i, quantity: 0 })
              .then(() => {
                o("POST", L, e)
                  .then((e) => {
                    t.remove(),
                      e.items.forEach((e) => {
                        S.querySelector(`[lsg-cart-line-item="${e.key}"]`)
                          ? (A && window.LSG_OPEN_CART(), P())
                          : D(e);
                      });
                  })
                  .catch((e) => {
                    console.error(e), alert(e);
                  });
              })
              .catch((e) => {
                C(t, e);
              });
          } else {
            let e = { id: i, quantity: a };
            "" === n
              ? ((e.selling_plan = null),
                o("POST", _, e)
                  .then((e) => {
                    s.classList.remove("lsg-cart-line-item__frequency-has-spa"),
                      P();
                  })
                  .catch((e) => {
                    C(t, e);
                  }))
              : ((e.selling_plan = n),
                o("POST", _, e)
                  .then((e) => {
                    P();
                  })
                  .catch((e) => {
                    C(t, e);
                  }));
          }
        })(t, e)
      );
  }
  function C(e, t) {
    console.error(t),
      (e.querySelector("[lsg-cart-error]").textContent = t),
      e.classList.add("lsg-cart-line-item__has-error");
  }
  window.k = function (e, t) {
    let i = t.querySelector('[type="submit"]');
    if (i) {
      let e = i.innerHTML;
      i.style.pointerEvents = "none";
      let t = document.createElement("div");
      t.classList.add("lsg-loading-spinner");
      for (let e = 0; e < 4; e++) {
        let e = document.createElement("div");
        t.appendChild(e);
      }
      (i.innerHTML = ""),
        i.appendChild(t),
        setTimeout(() => {
          (i.style.pointerEvents = "all"), (i.innerHTML = e);
        }, 1e3);
    }
    o("GET", q)
      .then((t) => {
        let i;
        let s = Object.fromEntries(e),
          n = parseInt(s["product-id"]),
          l = t.items.filter((e) => e.product_id === n);
        l.length > 0 && (i = l[0].handle);
        let r = 0;
        if (
          (l.forEach((e) => {
            r += e.quantity;
          }),
          void 0 !== i)
        )
          o("GET", `/products/${i}?view=lsg-metafields`).then((e) => {
            if (
              void 0 !== e.limit_quantity &&
              (r >= e.limit_quantity || s.quantity + r >= e.limit_quantity)
            ) {
              let t = `Error: You already have the maximum quantity of this item in your cart (${e.limit_quantity}).`;
              console.error(
                "[LSG] Quantity limited, cannot add to cart. Message:",
                t
              ),
                alert(t);
              return;
            }
            let t = { items: [{ id: s.id, quantity: s.quantity }] };
            void 0 !== s.selling_plan &&
              (t.items[0].selling_plan = s.selling_plan);
            let i = {};
            Object.entries(s).forEach((e) => {
              if (e[0].includes("properties")) {
                let t = e[0].split("[").pop().split("]")[0],
                  s = e[1];
                i[`${t}`] = s;
              }
            }),
              (t.items[0].properties = i),
              o("POST", L, t)
                .then((e) => {
                  e.items.forEach((e) => {
                    S.querySelector(`[lsg-cart-line-item="${e.key}"]`)
                      ? (A && window.LSG_OPEN_CART(), P())
                      : D(e);
                  });
                })
                .catch((e) => {
                  console.error(e), alert(e);
                });
          });
        else {
          let e = { items: [{ id: s.id, quantity: s.quantity }] };
          void 0 !== s.selling_plan &&
            (e.items[0].selling_plan = s.selling_plan);
          let t = {};
          Object.entries(s).forEach((e) => {
            if (e[0].includes("properties")) {
              let i = e[0].split("[").pop().split("]")[0],
                s = e[1];
              t[`${i}`] = s;
            }
          }),
            (e.items[0].properties = t),
            o("POST", L, e)
              .then((e) => {
                e.items.forEach((e) => {
                  S.querySelector(`[lsg-cart-line-item="${e.key}"]`)
                    ? (A && window.LSG_OPEN_CART(), P())
                    : D(e);
                });
              })
              .catch((e) => {
                console.error(e), alert(e);
              });
        }
      })
      .catch((e) => {
        console.error(e), alert(e);
      });
  };
  function D(e) {
    let t = window.Shopify.routes.root + "products/" + e.handle + ".js",
      i = `/products/${e.handle}?view=lsg-metafields`;
    o("GET", t).then((t) => {
      o("GET", i).then((i) => {
        (t.metafields = i),
          (function (e, t) {
            let i = S.getAttribute("data-section-id"),
              s = document
                .querySelector(`template[data-section-id  ="${i}"]`)
                .content.firstElementChild.cloneNode(!0),
              n = s.querySelector("img"),
              l = s.querySelector(".lsg-cart-line-item__detail-items"),
              o = s.querySelector(".lsg-cart-line-item__title"),
              a = s.querySelector(".lsg-cart-line-item__variant-title"),
              d = s.querySelector(".lsg-cart-line-item__options-list"),
              u = s.querySelector("[lsg-cart-qty-input]"),
              h = s.querySelector("[lsg-price-group]");
            if (
              (s.setAttribute("lsg-cart-line-item", e.key),
              (n.src = c(e.image, "medium")),
              (o.textContent = e.product_title),
              a && (a.textContent = e.variant_title),
              d && "Default Title" !== e.options_with_values[0].value
                ? e.options_with_values.forEach((e) => {
                    let t = document.createElement("li");
                    t.classList.add("lsg-cart-line-item__option-list-item"),
                      (t.textContent = `${e.name}: ${e.value}`),
                      d.append(t);
                  })
                : d.remove(),
              e.properties)
            ) {
              let t = Object.entries(e.properties);
              if (t.length) {
                let e = document.createElement("ul");
                e.classList.add("lsg-cart-line-item__properties-list"),
                  t.forEach((t) => {
                    if ("_" === t[0].charAt(0) || "" === t[1]) return;
                    let i = document.createElement("li");
                    i.classList.add("lsg-cart-line-item__properties-list-item"),
                      (i.textContent = `${t[0]}: ${t[1]}`),
                      e.append(i);
                  }),
                  l.append(e);
              }
            }
            u.setAttribute("value", e.quantity),
              void 0 !== t.metafields.limit_quantity &&
                u.setAttribute("max", t.metafields.limit_quantity);
            let g = !1;
            if (
              void 0 !== t.selling_plan_groups &&
              t.selling_plan_groups.length > 0
            ) {
              let i = t.variants.find((t) => t.id === parseInt(e.variant_id)),
                n = t.metafields.variants.find(
                  (t) => t.id === parseInt(e.variant_id)
                ).in_cart_frequency;
              if (void 0 !== n && !1 !== n) {
                let n = document.createElement("div");
                n.classList.add("lsg-cart-line-item__frequency"),
                  n.setAttribute("lsg-cart-frequency-group", "");
                let l = document.createElement("button"),
                  r = document.createElement("span");
                l.classList.add("lsg-button", "lsg-button__style-2"),
                  l.setAttribute("type", "button"),
                  l.setAttribute("lsg-cart-selling-plan-btn", ""),
                  (r.textContent = "Subscribe & Save"),
                  l.append(r),
                  n.append(l);
                let o = document.createElement("div"),
                  a = document.createElement("select"),
                  c = document.createElement("option");
                o.classList.add("lsg-select-wrapper"),
                  a.setAttribute("name", "selling_plan"),
                  a.setAttribute("lsg-cart-selling-plan-select", ""),
                  (c.textContent = "One-Time Purchase"),
                  c.setAttribute("lsg-cart-freq-variant", i.id),
                  c.setAttribute("value", ""),
                  a.append(c);
                let d = e.selling_plan_allocation?.selling_plan?.id;
                if (
                  (d &&
                    (n.classList.add("lsg-cart-line-item__frequency-has-spa"),
                    (g = !0)),
                  i.selling_plan_allocations.forEach((e, s) => {
                    let n = t.selling_plan_groups.find(
                        (t) => t.id === e.selling_plan_group_id
                      ),
                      l = n.selling_plans.find(
                        (t) => t.id === parseInt(e.selling_plan_id)
                      );
                    if (
                      parseInt(n.app_id) === t.metafields.subscription_app_id
                    ) {
                      let t = document.createElement("option");
                      t.setAttribute("lsg-cart-freq-variant", i.id),
                        t.setAttribute("value", l.id),
                        (t.textContent = l.name),
                        1 === a.childElementCount &&
                          t.setAttribute("lsg-cart-first-selling-plan", ""),
                        e.selling_plan_id === d &&
                          t.setAttribute("selected", ""),
                        a.append(t);
                    }
                  }),
                  void 0 === t.metafields.limit_quantity)
                ) {
                  let e = document.createElement("option"),
                    s = "Add Another";
                  void 0 !== t.metafields.add_another_text &&
                    (s = t.metafields.add_another_text),
                    (e.textContent = s),
                    e.setAttribute("lsg-cart-freq-add-variant", i.id),
                    e.setAttribute("value", ""),
                    a.append(e);
                }
                o.append(a),
                  n.append(o),
                  s.append(n),
                  s.classList.add("lsg-cart-line-item__has-frequency");
              }
            }
            let p = h.querySelector("[lsg-price]"),
              m = e.price,
              f = e.price;
            g
              ? ((m = e.selling_plan_allocation.price),
                (f = e.selling_plan_allocation.compare_at_price))
              : t.compare_at_price &&
                t.compare_at_price !== e.price &&
                ((m = e.price), (f = t.compare_at_price));
            let v = f;
            if (
              ((m *= e.quantity),
              (f *= e.quantity),
              (p.textContent = r.format(m / 100)),
              h.append(p),
              m !== f)
            ) {
              let e = document.createElement("span");
              e.setAttribute("lsg-price-divider", ""),
                (e.textContent = "-"),
                h.append(e);
              let t = document.createElement("span");
              t.classList.add("lsg-price__price-compare"),
                t.setAttribute("lsg-price-compare", v),
                (t.textContent = r.format(f / 100)),
                h.append(t);
            }
            w(s),
              x.prepend(s),
              S.classList.remove("lsg-cart-empty"),
              A && window.LSG_OPEN_CART();
          })(e, t),
          P();
      });
    });
  }
  window.P = function () {
    o("GET", q).then((e) => {
      x.querySelectorAll("[lsg-cart-line-item]").forEach((t) => {
        let i = t.getAttribute("lsg-cart-line-item");
        e.items.find((e) => e.key === i) || t.remove();
      });
      let t = [];
      e.items.forEach((e) => {
        if (!x.querySelector(`[lsg-cart-line-item="${e.key}"]`)) {
          let i = D(e);
          t.push(i);
        }
      }),
        Promise.all(t).then(() => {
          o("GET", q).then((e) => {
            (function (e) {
              if (e.item_count > 0) {
                var t;
                (t = e.items[0].product_id),
                  y.forEach((e) => {
                    E(t, e);
                  });
              }
              0 === e.item_count
                ? S.classList.add("lsg-cart-empty")
                : S.classList.remove("lsg-cart-empty");
              let i = S.querySelector("[lsg-cart-product-list]");
              i &&
                e.items.forEach((e) => {
                  let t = i.querySelector(`[lsg-cart-line-item="${e.key}"]`);
                  if (t) {
                    t.querySelector("[lsg-cart-qty-input]").setAttribute(
                      "value",
                      e.quantity
                    );
                    let s = t.querySelector("[lsg-price]"),
                      n = t.querySelector("[lsg-price-compare]");
                    if (n) {
                      let t = n.getAttribute("lsg-price-compare") * e.quantity;
                      n.innerHTML = r.format(t / 100);
                    }
                    (s.innerHTML = r.format(e.line_price / 100)), i.append(t);
                  } else console.error(`[LSG] Key not found (${e.key})!`);
                }),
                $ &&
                  W &&
                  "layout-1" === I &&
                  (e.items.length > 0
                    ? T.append($)
                    : W.parentElement === S && S.insertBefore($, W)),
                $ &&
                  W &&
                  "layout-2" === I &&
                  (e.items.length > 1
                    ? T.append($)
                    : W.parentElement === S && S.insertBefore($, W));
              let s = S.querySelector("[lsg-cart-shipping-progress]");
              if (s) {
                let t = parseInt(
                    s.getAttribute("lsg-cart-shipping-progress-threshold")
                  ),
                  i = s.getAttribute("lsg-cart-shipping-progress-success-text"),
                  n = s.querySelector("[lsg-cart-shipping-progress-text]"),
                  l = s.querySelector("[lsg-cart-shipping-progress-bar]"),
                  o = S.querySelector("[lsg-cart-subtotal-shipping]"),
                  a = Math.max(t - e.total_price, 0),
                  c = Math.min((e.total_price / t) * 100, 100);
                (l.style.width = `${c}%`),
                  100 === c
                    ? (S.classList.add("lsg-cart-hide-upsells"),
                      (n.innerHTML = i),
                      o && (o.innerHTML = "FREE"))
                    : (S.classList.remove("lsg-cart-hide-upsells"),
                      (n.innerHTML = `
                <span class="lsg-cart-shipping-progress__prefix">You are</span>
                <span class="lsg-cart-shipping-progress__amount">${r.format(
                  a / 100
                )}</span>
                <span class="lsg-cart-shipping-progress__suffix">from <strong>FREE SHIPPING</strong></span>
            `),
                      o && (o.innerHTML = "Calculated at checkout"));
              }
              let n = S.querySelector("[lsg-cart-subtotal]");
              if (n) {
                let t = n.querySelector(".lsg-cart-subtotal__price"),
                  s = n.querySelector("[lsg-cart-subtotal-count]"),
                  l = n.querySelector("[lsg-cart-subtotal-amount]"),
                  o = n.querySelector("[lsg-cart-subtotal-compare]"),
                  a = 0;
                i &&
                  e.items.forEach((e) => {
                    let t = i.querySelector(`[lsg-cart-line-item="${e.key}"]`);
                    if (t) {
                      let i = t.querySelector("[lsg-price-compare]");
                      if (i) {
                        let t =
                          i.getAttribute("lsg-price-compare") * e.quantity;
                        a += t;
                      } else a += e.price * e.quantity;
                    }
                  });
                let c = 1 === e.item_count ? "Item" : "Items";
                if (
                  ((s.innerHTML = `(${e.item_count} ${c})`),
                  a !== e.total_price)
                ) {
                  if (o) o.textContent = r.format(a / 100);
                  else {
                    let e = document.createElement("span");
                    e.setAttribute("lsg-cart-subtotal-compare", ""),
                      (e.textContent = r.format(a / 100)),
                      t.append(e);
                    let i = document.createElement("span");
                    i.setAttribute("lsg-cart-subtotal-divider", ""),
                      (i.textContent = "-"),
                      t.append(i);
                  }
                  n.classList.remove("lsg-cart-subtotal__no-compare");
                } else n.classList.add("lsg-cart-subtotal__no-compare");
                (l.textContent = r.format(e.total_price / 100)), t.append(l);
              }
              if (
                (document
                  .querySelectorAll("[lsg-cart-icon-badge]")
                  .forEach((t) => {
                    t.textContent = e.item_count;
                  }),
                A)
              ) {
                let t = document
                  .querySelector(".lsg-slidecart-rebuild")
                  .querySelector("[lsg-cart-checkout-btn]");
                t.setAttribute("href", "/checkout"),
                  e.items.forEach((i) => {
                    let s = `/products/${i.handle}?view=lsg-metafields`;
                    void 0 !== i.selling_plan_allocation &&
                      o("GET", s).then((i) => {
                        void 0 !== i.discount_pair_item &&
                          i.discount_pair_item &&
                          void 0 !== i.discount_pair_targets &&
                          i.discount_pair_targets.forEach((s) => {
                            e.items.forEach((e) => {
                              if (
                                e.product_id === s.id &&
                                void 0 !== e.selling_plan_allocation &&
                                void 0 !== i.discount_pair_code
                              ) {
                                let e = `/checkout?discount=${i.discount_pair_code}`;
                                t.setAttribute("href", e);
                              }
                            });
                          });
                      });
                  });
              }
            })(e);
          });
        });
    });
  };
  x &&
    x.querySelectorAll("[lsg-cart-line-item]").forEach((e) => {
      w(e);
    }),
    document.querySelectorAll(".shopify-product-form").forEach((e) => {
      e.addEventListener("submit", (t) => {
        t.preventDefault(), k(new FormData(t.target), e);
      });
    });
  let I = S.getAttribute("lsg-cart-upsell-placement"),
    $ = S.querySelector("[lsg-recommendations]"),
    T = S.querySelector(".lsg-slidecart-rebuild__inner-wrapper"),
    W = $.nextElementSibling;
  ({
    init: () => {
      let e = document.querySelector(".lsg-slidecart-rebuild"),
        t =
          (new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
          }),
          window.location.pathname);
      if (e && "/cart" != t) {
        let t;
        function i() {
          document.documentElement.style.setProperty(
            "--window-inner-height",
            `${window.innerHeight}px`
          );
        }
        i(), window.addEventListener("resize", i);
        let l = document.querySelector("[lsg-slidecart-rebuild-overlay]"),
          r = document.querySelectorAll("[lsg-slidecart-open]"),
          o = document.querySelectorAll("[lsg-slidecart-rebuild-close]"),
          a = document.querySelectorAll(".shopify-product-form");
        function s() {
          e.classList.add("lsg-slidecart-rebuild__active"),
            l.classList.add("lsg-slidecart-rebuild__active"),
            (t = window.scrollY),
            document.documentElement.classList.add("is-locked"),
            e.addEventListener("pointermove", (e) => {
              e.preventDefault;
            });
        }
        function n() {
          e.classList.remove("lsg-slidecart-rebuild__active"),
            l.classList.remove("lsg-slidecart-rebuild__active"),
            document.documentElement.classList.remove("is-locked"),
            e.removeEventListener("pointermove", (e) => {
              e.preventDefault;
            }),
            window.scrollTo(0, t);
        }
        document.querySelector("[lsg-slidecart-rebuild-alert]"),
          (window.LSG_OPEN_CART = function () {
            s();
          }),
          (window.LSG_CART_UPDATE = function () {
            e.classList.add("lsg-slidecart-rebuild__active"),
              l.classList.add("lsg-slidecart-rebuild__active");
          }),
          window.location.href.indexOf("#cart") > -1 && s(),
          r.forEach((e) => {
            e.addEventListener("click", (e) => {
              e.preventDefault(), s();
            });
          }),
          o.forEach((e) => {
            e.addEventListener("click", (e) => {
              n();
            });
          }),
          a.forEach((e) => {}),
          document.addEventListener("shopify:section:select", (t) => {
            t.target.contains(e) && s();
          }),
          document.addEventListener("shopify:section:deselect", (t) => {
            t.target.contains(e) && n();
          });
      }
    },
  }).init(),
    {
      init: () => {
        let e = document.querySelectorAll(".lsg-buybox-rebuild"),
          t = new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
          });
        e.forEach((e) => {
          let i = new Flickity(
              e.querySelector(".lsg-buybox-rebuild__gallery"),
              {
                wrapAround: !0,
                groupCells: !0,
                pageDots: !1,
                prevNextButtons: !1,
                setGallerySize: !1,
                on: {
                  change: function (e) {
                    a(e);
                  },
                },
              }
            ),
            s = e.querySelector("[lsg-carousel-nav]"),
            n = s.querySelector("[lsg-carousel-nav-prev]"),
            l = s.querySelector("[lsg-carousel-nav-dots]"),
            r = l.querySelectorAll("[lsg-carousel-nav-dot]"),
            o = s.querySelector("[lsg-carousel-nav-next]");
          function a(e) {
            r.forEach((e) => {
              e.parentElement.classList.remove("lsg-dot-selected");
            }),
              s
                .querySelector(`[lsg-carousel-nav-dot-index="${e}"]`)
                .parentElement.classList.add("lsg-dot-selected"),
              n.removeAttribute("disabled"),
              o.removeAttribute("disabled"),
              i.isWrapping || 0 !== e
                ? i.isWrapping ||
                  e !== i.cells.length - 1 ||
                  o.setAttribute("disabled", !0)
                : n.setAttribute("disabled", !0);
          }
          (n = (s = e.querySelector("[lsg-carousel-nav]")).querySelector(
            "[lsg-carousel-nav-prev]"
          )),
            (r = (l = s.querySelector(
              "[lsg-carousel-nav-dots]"
            )).querySelectorAll("[lsg-carousel-nav-dot]")),
            (o = s.querySelector("[lsg-carousel-nav-next]")),
            a(0),
            n.addEventListener("click", (e) => {
              i.previous();
            }),
            o.addEventListener("click", (e) => {
              i.next();
            }),
            r.forEach((e) => {
              e.addEventListener("click", (t) => {
                let s = e.getAttribute("lsg-carousel-nav-dot-index");
                i.select(s);
              });
            });
          let c = e.querySelector(".lsg-nutrition-modal__btn"),
            d = e.querySelector(".lsg-nutrition-modal");
          c &&
            (c.addEventListener("click", (e) => {
              (d.style.opacity = 1), (d.style.pointerEvents = "all");
            }),
            d.addEventListener("click", (e) => {
              (d.style.opacity = 0), (d.style.pointerEvents = "none");
            }));
          let u = e.getAttribute("data-section-id"),
            h = e.querySelectorAll("[lsg-form-wrapper]"),
            g = e.querySelectorAll(".lsg-collection-switcher__short-name"),
            p = e.querySelectorAll("[lsg-switcher-btn]"),
            m = e.querySelectorAll("[lsg-switcher-select]"),
            f = e.querySelectorAll("[lsg-accordion-item]");
          f.forEach((e) => {
            e.addEventListener("click", (t) => {
              let i = e.parentElement;
              i.classList.contains("lsg-accordion-item-open")
                ? i.classList.remove("lsg-accordion-item-open")
                : (f.forEach((e) => {
                    e.parentElement.classList.remove("lsg-accordion-item-open");
                  }),
                  i.classList.add("lsg-accordion-item-open"));
            });
          }),
            p.forEach((t) => {
              t.addEventListener("click", (i) => {
                let s = t.getAttribute("lsg-switcher-btn"),
                  n = t.getAttribute("lsg-switcher-name"),
                  l = e.querySelector(`[lsg-form-wrapper="${s}"]`);
                g.forEach((e) => {
                  e.classList.remove("lsg-short-name-active");
                }),
                  e
                    .querySelector(
                      `.lsg-collection-switcher__short-name[lsg-switcher-name="${n}"]`
                    )
                    .classList.add("lsg-short-name-active"),
                  p.forEach((e) => {
                    e.classList.remove("lsg-switcher-active");
                  }),
                  t.classList.add("lsg-switcher-active"),
                  h.forEach((e) => {
                    e.classList.remove("lsg-buybox-rebuild__active");
                  }),
                  l.classList.add("lsg-buybox-rebuild__active"),
                  m.forEach((e) => {
                    e.value = s;
                  });
              });
            }),
            m.forEach((t) => {
              t.addEventListener("change", (i) => {
                let s = t.value,
                  n = t
                    .querySelector(`[value="${s}"]`)
                    .getAttribute("lsg-switcher-name"),
                  l = e.querySelector(`[lsg-form-wrapper="${s}"]`);
                g.forEach((e) => {
                  e.classList.remove("lsg-short-name-active");
                }),
                  e
                    .querySelector(
                      `.lsg-collection-switcher__short-name[lsg-switcher-name="${n}"]`
                    )
                    .classList.add("lsg-short-name-active"),
                  h.forEach((e) => {
                    e.classList.remove("lsg-buybox-rebuild__active");
                  }),
                  l.classList.add("lsg-buybox-rebuild__active"),
                  m.forEach((e) => {
                    e.value = s;
                  }),
                  p.forEach((e) => {
                    e.classList.remove("lsg-switcher-active");
                  }),
                  e
                    .querySelector(`[lsg-switcher-btn="${s}"]`)
                    .classList.add("lsg-switcher-active");
              });
            }),
            h.forEach((s) => {
              let n = s.getAttribute("lsg-form-wrapper"),
                l = JSON.parse(
                  document.getElementById(`ProductJson-${u}-${n}`).textContent
                ),
                r = s.querySelector(`#productSelect-${n}`),
                o = s.querySelector(`#quantity-${n}`),
                a = s.querySelector(`#sellingPlan-${n}`),
                c = s.querySelectorAll("[lsg-options-group]"),
                d = e.querySelectorAll("[lsg-add-on-radio]"),
                h = s.querySelectorAll("[lsg-freq-variant]"),
                g = s.querySelector(".lsg-buybox-rebuild__sticky-atc"),
                p = e.querySelectorAll("[lsg-add-on-toggle]"),
                m = s.querySelectorAll("[lsg-buybox-qty-minus]"),
                f = s.querySelectorAll("[lsg-buybox-qty-plus]"),
                v = s.querySelectorAll("[lsg-buybox-qty-input]");
              if (
                ((r.style.display = "none"),
                c.forEach((e) => {
                  let t = e.querySelectorAll("[lsg-buybox-option]");
                  t.forEach((e) => {
                    let i = e.getAttribute("lsg-option-position");
                    switch (e.getAttribute("lsg-option-type")) {
                      case "select":
                        e.querySelector(
                          `[name="option-${i}"]`
                        ).addEventListener("change", (e) => {
                          E(t);
                        });
                        break;
                      case "radio":
                        e.querySelectorAll(`[name="option-${i}"]`).forEach(
                          (e) => {
                            e.addEventListener("change", (e) => {
                              E(t);
                            });
                          }
                        );
                    }
                  });
                }),
                p.forEach((t) => {
                  t.addEventListener("change", (i) => {
                    let s = t.value;
                    e
                      .querySelectorAll(
                        `[lsg-add-on-radio][value="${t.value}"]`
                      )
                      .forEach((e) => {
                        e.checked = !0;
                      }),
                      p.forEach((e) => {
                        e.value = s;
                      });
                    let n = e.querySelector("[lsg-combo-price-addon]");
                    n &&
                      ("none" === s
                        ? n.classList.add("lsg-combo-price__comp")
                        : n.classList.remove("lsg-combo-price__comp")),
                      r.dispatchEvent(new Event("change"));
                  });
                }),
                d.forEach((t) => {
                  t.addEventListener("change", (i) => {
                    if ("none" === t.value) {
                      e
                        .querySelectorAll(
                          `[lsg-add-on-radio][value="${t.value}"]`
                        )
                        .forEach((e) => {
                          e.checked = !0;
                        }),
                        p.forEach((e) => {
                          e.value = t.value;
                        });
                      let i = e.querySelector("[lsg-combo-price-addon]");
                      i && i.classList.add("lsg-combo-price__comp");
                    } else {
                      e
                        .querySelectorAll(
                          `[lsg-add-on-radio][value="${t.value}"]`
                        )
                        .forEach((e) => {
                          e.checked = !0;
                        }),
                        p.forEach((e) => {
                          e.value = t.value;
                        });
                      let i = e.querySelector("[lsg-combo-price-addon]");
                      i && i.classList.remove("lsg-combo-price__comp");
                    }
                    r.dispatchEvent(new Event("change"));
                  });
                }),
                h.length > 0)
              ) {
                let e = h[0].getAttribute("lsg-freq-variant");
                l.variants.find((t) => t.id === parseInt(e));
              }
              function y(e) {
                o.setAttribute("value", e),
                  v.forEach((t) => {
                    t.setAttribute("value", e);
                  }),
                  r.dispatchEvent(new Event("change"));
              }
              function b(e) {
                var i, n;
                let l = s.querySelectorAll("[lsg-price-regular]"),
                  r = s.querySelectorAll("[lsg-price-compare]"),
                  o = s.querySelector("[lsg-add-on-price]:checked"),
                  c = 0;
                o && (c = parseInt(o.getAttribute("lsg-add-on-price")));
                let d = 0,
                  u = 0;
                a.value &&
                  ((i = a.value),
                  e.find((e) => e.id === parseInt(i)),
                  (d = e.selling_plan_allocations[0].price),
                  (n = a.value),
                  e.find((e) => e.id === parseInt(n)),
                  (u = e.selling_plan_allocations[0].compare_at_price));
                let h = c + d,
                  g = c + u;
                l.forEach((e) => {
                  e.textContent = t.format(h / 100);
                }),
                  g > 0 &&
                    r.forEach((e) => {
                      e.textContent = t.format(g / 100);
                    });
              }
              function E(e) {
                let t;
                let i = [];
                e.forEach((e) => {
                  let t = e.getAttribute("lsg-option-position");
                  switch (e.getAttribute("lsg-option-type")) {
                    case "select":
                      let s = e.querySelector(`[name="option-${t}"]`);
                      i.push([t, s.value]);
                      break;
                    case "radio":
                      let n = e.querySelector(`[name="option-${t}"]:checked`);
                      i.push([t, n.value]);
                  }
                }),
                  i.sort(),
                  i.forEach((e) => {
                    let i = e[1]
                      .toLowerCase()
                      .replace(/[^\w\u00C0-\u024f]+/g, "-")
                      .replace(/^-+|-+$/g, "");
                    void 0 === t ? (t = i) : (t += `-${i}`);
                  });
                let s = r.querySelector(`[lsg-option-handle="${t}"`);
                (r.value = s.value), r.dispatchEvent(new Event("change"));
              }
              h.forEach((e) => {
                let t = e.querySelector("[lsg-radio-otp]"),
                  i = e.querySelector("[lsg-radio-sub]"),
                  s = e.querySelector(".lsg-freq__select"),
                  n = e.querySelector("[lsg-freq-select]"),
                  r = e.getAttribute("lsg-freq-variant"),
                  o = l.variants.find((e) => e.id === parseInt(r));
                if (
                  (t.addEventListener("click", (t) => {
                    (a.value = ""),
                      s.classList.remove("lsg-freq-select-active"),
                      e.setAttribute("lsg-freq-selection", "otp"),
                      b(o),
                      c("");
                  }),
                  i.addEventListener("click", (t) => {
                    (a.value = n.value),
                      s.classList.add("lsg-freq-select-active"),
                      e.setAttribute("lsg-freq-selection", "sub"),
                      c(n.value);
                  }),
                  n.addEventListener("change", (e) => {
                    (a.value = n.value), c(n.value);
                  }),
                  g)
                ) {
                  let s = g.querySelector("[lsg-freq-select]");
                  s &&
                    s.addEventListener("change", (l) => {
                      (a.value = s.value),
                        "" === s.value
                          ? (e.setAttribute("lsg-freq-selection", "otp"),
                            (t.checked = !0))
                          : (e.setAttribute("lsg-freq-selection", "sub"),
                            (n.value = s.value),
                            (i.checked = !0));
                    });
                }
                function c(e) {
                  if (g) {
                    let t = g.querySelector("[lsg-freq-select]");
                    t && (t.value = e);
                  }
                }
              }),
                m.forEach((e) => {
                  e.addEventListener("click", (e) => {
                    let t = parseInt(o.value) - 1;
                    t >= 1 && y(t);
                  });
                }),
                f.forEach((e) => {
                  e.addEventListener("click", (e) => {
                    let t = parseInt(o.value) + 1;
                    t <= 15 && y(t);
                  });
                });
              let S = !0;
              if (
                (r.addEventListener("change", (t) => {
                  let n = l.variants.find(
                    (e) => e.id === parseInt(t.target.value)
                  );
                  s.querySelectorAll("[lsg-atc-controls]").forEach((e) => {
                    n.available
                      ? e.removeAttribute("lsg-atc-controls-sold-out")
                      : e.setAttribute("lsg-atc-controls-sold-out", "");
                  }),
                    b(n),
                    c.forEach((e) => {
                      e.querySelectorAll("[lsg-buybox-option]").forEach((e) => {
                        let t = e.getAttribute("lsg-option-position"),
                          i = e.getAttribute("lsg-option-type"),
                          s = n.options[t];
                        switch (i) {
                          case "select":
                            e.querySelector(`[name="option-${t}"]`).value = s;
                            break;
                          case "radio":
                            e.querySelector(
                              `[name="option-${t}"][value="${s}"]`
                            ).checked = !0;
                        }
                      });
                    }),
                    S ||
                      (function (t) {
                        let s = e
                          .querySelector(".lsg-buybox-rebuild__gallery")
                          .querySelector(`[lsg-attached-variant="${t.id}"]`);
                        s && i.select(s.getAttribute("lsg-slide-index"));
                      })(n),
                    (S = !1);
                }),
                r.dispatchEvent(new Event("change")),
                g)
              ) {
                let t = g.querySelector("[lsg-sticky-atc-open-btn]"),
                  i = g.querySelector("[lsg-sticky-atc-close-btn]");
                t.addEventListener("click", (t) => {
                  e.querySelectorAll(".lsg-buybox-rebuild__sticky-atc").forEach(
                    (e) => {
                      e.classList.remove("lsg-sticky-atc-closed");
                    }
                  );
                }),
                  i.addEventListener("click", (t) => {
                    e.querySelectorAll(
                      ".lsg-buybox-rebuild__sticky-atc"
                    ).forEach((e) => {
                      e.classList.add("lsg-sticky-atc-closing"),
                        setTimeout(function () {
                          e.classList.add("lsg-sticky-atc-closed");
                        }, 500),
                        setTimeout(function () {
                          e.classList.remove("lsg-sticky-atc-closing");
                        }, 1e3);
                    });
                  }),
                  window.addEventListener("scroll", (e) => {
                    q();
                  });
                let s = !1;
                function q() {
                  let t = e.getBoundingClientRect().top,
                    i = e.offsetHeight + t;
                  i < 0 && !1 === s
                    ? (g.setAttribute("lsg-sticky-atc-show", !0), (s = !0))
                    : i > 0 &&
                      !0 === s &&
                      (g.setAttribute("lsg-sticky-atc-show", !1), (s = !1));
                }
                q();
              }
            });
        });
      },
    }.init(),
    {
      init: () => {
        document.querySelectorAll(".lsg-buybox").forEach((t) => {
          let i = {
              imagesLoaded: !0,
              setGallerySize: !0,
              prevNextButtons: !1,
              pageDots: !1,
              on: {
                change: function (e) {
                  p(e);
                },
              },
            },
            s = t.querySelector(".lsg-buybox__gallery-actual"),
            n = new /*@__PURE__*/ (e(d))(s, i);
          window.addEventListener(
            "resize",
            a((s) => {
              let l = t.querySelector(".lsg-buybox__gallery-actual");
              /*@__PURE__*/ e(d).data(l).destroy(),
                (n = new /*@__PURE__*/ (e(d))(l, i)),
                g(t, 0);
            }, 150)
          );
          let l = t.querySelector("[lsg-carousel-nav]"),
            o = l.querySelector("[lsg-carousel-nav-prev]"),
            c = l.querySelector("[lsg-carousel-nav-dots]"),
            u = c.querySelectorAll("[lsg-carousel-nav-dot]"),
            h = l.querySelector("[lsg-carousel-nav-next]");
          function g(e, t) {
            (o = (l = e.querySelector("[lsg-carousel-nav]")).querySelector(
              "[lsg-carousel-nav-prev]"
            )),
              (u = (c = l.querySelector(
                "[lsg-carousel-nav-dots]"
              )).querySelectorAll("[lsg-carousel-nav-dot]")),
              (h = l.querySelector("[lsg-carousel-nav-next]")),
              p(t);
          }
          function p(e) {
            u.forEach((e) => {
              e.parentElement.classList.remove("lsg-dot-selected");
            }),
              l
                .querySelector(`[lsg-carousel-nav-dot-index="${e}"]`)
                .parentElement.classList.add("lsg-dot-selected"),
              o.removeAttribute("disabled"),
              h.removeAttribute("disabled"),
              n.isWrapping || 0 !== e
                ? n.isWrapping ||
                  e !== n.cells.length - 1 ||
                  h.setAttribute("disabled", !0)
                : o.setAttribute("disabled", !0);
          }
          g(t, 0),
            o.addEventListener("click", (e) => {
              n.previous();
            }),
            h.addEventListener("click", (e) => {
              n.next();
            }),
            u.forEach((e) => {
              e.addEventListener("click", (t) => {
                let i = e.getAttribute("lsg-carousel-nav-dot-index");
                n.select(i);
              });
            });
          let m = t.querySelector(".shopify-product-form"),
            f = t.getAttribute("data-product-id"),
            v = document.getElementById(`ProductJson-${f}`),
            y = m.querySelectorAll('input[type="radio"][name="plan"]'),
            b = m.querySelector('input[name="selling_plan"]'),
            E = m.querySelector("select[lsg-buybox-freq-select]"),
            S = m.querySelector('input[name="quantity"]'),
            q = S.getAttribute("max"),
            L = m.querySelector("[lsg-buybox-qty-minus-btn]"),
            _ = m.querySelector("[lsg-buybox-qty-plus-btn]"),
            A = m.querySelector('select[name="id"]'),
            x = m.querySelector("[lsg-buybox-atc-controls]");
          function w() {
            let e = m
              .querySelector('input[type="radio"][name="plan"]:checked')
              .getAttribute("lsg-buybox-savings");
            m.querySelector(
              "[lsg-buybox-savings-text]"
            ).textContent = `You're saving ${r.format(e / 100)}`;
          }
          m.querySelector("[lsg-buybox-atc-btn]"),
            v && JSON.parse(v.textContent),
            (A.style.display = "none"),
            y.forEach((e) => {
              e.addEventListener("change", (e) => {
                (function () {
                  let e;
                  let t = m.querySelector(
                      'input[type="radio"][name="plan"]:checked'
                    ),
                    i = t.getAttribute("lsg-buybox-selling-plan-id");
                  E && (e = E.value),
                    "" === i
                      ? (b.value = "")
                      : void 0 !== e
                      ? (b.value = e)
                      : (b.value = i),
                    (A.value = t.getAttribute("lsg-buybox-variant-id")),
                    "" !== b.value
                      ? ((S.value = 1),
                        x.classList.remove("lsg-buybox__qty-active"))
                      : x.classList.add("lsg-buybox__qty-active"),
                    w();
                })();
              });
            }),
            E &&
              (E.addEventListener("click", (e) => {
                e.stopPropagation();
              }),
              E.addEventListener("change", (e) => {
                b.value = E.value;
              })),
            L &&
              L.addEventListener("click", (e) => {
                let t = parseInt(S.value) - 1;
                t >= 1 && (S.value = t);
              }),
            _ &&
              _.addEventListener("click", (e) => {
                let t = parseInt(S.value) + 1;
                t <= q && (S.value = t);
              }),
            w();
        });
      },
    }.init(),
    {
      init: () => {
        window.flickityInitialized = true;
        document.querySelectorAll(".lsg-announcement").forEach((e) => {
          window.addEventListener("scroll", (t) => {
            let i = e.getBoundingClientRect().top,
              s = Math.max(
                parseInt(
                  getComputedStyle(document.documentElement).getPropertyValue(
                    "--lsg-announcement-bar-height"
                  )
                ) + i,
                0
              );
            document.documentElement.style.setProperty(
              "--lsg-announcement-bar-delta",
              `${s}px`
            );
          });
          let t = e.querySelector("[lsg-slider]"),
            i,
            s = { wrapAround: !0, prevNextButtons: !1, pageDots: !1 };
          if (t) {
            let e = t.getAttribute("lsg-slider-mode");
            "marquee" === e
              ? ((s.resize = !0),
                (s.percentPosition = !0),
                (s.setGallerySize = !0),
                (s.draggable = !1),
                (function () {
                  let e = window.innerWidth,
                    i = t.querySelectorAll(".lsg-announcement__slide"),
                    s = 0;
                  if (
                    (i.forEach((e) => {
                      s += e.offsetWidth;
                    }),
                    s < e && 0 !== s)
                  ) {
                    let n = 2 * Math.ceil(e / s);
                    for (let e = 0; e < n; e++)
                      i.forEach((e) => {
                        let i = e.cloneNode(!0);
                        t.appendChild(i);
                      });
                  }
                })())
              : (s.autoPlay = 5e3),
              (i = new Flickity(t, s)),
              "marquee" === e &&
                (function () {
                  let e;
                  function s() {
                    (i.x -= 1.5),
                      i.settle(i.x),
                      (e = window.requestAnimationFrame(s));
                  }
                  (i.x = 0),
                    s(),
                    t.addEventListener("mouseenter", (t) => {
                      e && (window.cancelAnimationFrame(e), (e = void 0));
                    }),
                    t.addEventListener("mouseleave", (e) => {
                      s();
                    });
                })();
          }
        });
      },
    }.init(),
    {
      init: () => {
        let e = document.querySelectorAll(".lsg-header"),
          t = document.getElementById("lsg-header-group");
        e.forEach((e) => {
          let i = window.scrollY;
          function s(e) {
            let t = e.querySelector("[lsg-mobile-menu-btn]");
            t.addEventListener("click", (i) => {
              t.classList.contains("lsg-mobile-menu-btn-active") ? m(e) : p(e);
            }),
              e.querySelectorAll("[lsg-meganav-btn]").forEach((e) => {
                e.addEventListener("click", (t) => {
                  let i = e.getAttribute("lsg-meganav-handle"),
                    s = document.querySelector(
                      `.lsg-meganav[lsg-meganav-handle="${i}"]`
                    ),
                    n = document.getElementById("lsg-meganav-group");
                  s
                    ? s.classList.contains("lsg-meganav-active")
                      ? (g(i), n.classList.remove("lsg-meganav-group-active"))
                      : h(i)
                    : console.error(
                        `No LSG MegaNav with the handle '${i}' was found, please check your settings.`
                      );
                });
              }),
              e.querySelectorAll("[lsg-meganav-link]").forEach((e) => {
                e.addEventListener("mouseenter", (t) => {
                  let i = e.getAttribute("lsg-meganav-handle"),
                    s = document.querySelector(
                      `.lsg-meganav[lsg-meganav-handle="${i}"]`
                    );
                  if (s) {
                    if (s.classList.contains("lsg-meganav-active")) return;
                    h(i);
                  } else
                    console.error(
                      `No LSG MegaNav with the handle '${i}' was found, please check your settings.`
                    );
                });
              });
          }
          window.addEventListener("scroll", (e) => {
            let s = window.scrollY,
              n = s - i;
            s > 500 &&
            n > 0 &&
            !document
              .getElementById("lsg-header-group")
              .classList.contains("lsg-meganav-open")
              ? (t.style.transform = "translateY(-200px)")
              : (t.style.transform = "translateY(0)"),
              (i = s);
          }),
            s(e),
            document.addEventListener("shopify:section:load", (e) => {
              console.log("shopify:section:load");
            }),
            document.addEventListener("shopify:section:select", (e) => {
              console.log("shopify:section:select"),
                s(e.target.querySelector(".lsg-header"));
            }),
            document.addEventListener("shopify:block:select", (e) => {
              console.log("shopify:block:select");
            }),
            document.addEventListener("shopify:section:deselect", (e) => {
              console.log("shopify:section:deselect");
            });
        });
      },
    }.init(),
    {
      init: () => {
        document.querySelectorAll(".lsg-meganav").forEach((e) => {
          function t(e) {
            e.addEventListener("mouseleave", (t) => {
              let i = e.getAttribute("lsg-meganav-handle"),
                s = document.getElementById("lsg-meganav-group");
              g(i), s.classList.remove("lsg-meganav-group-active");
            });
            let t = e.querySelector("[lsg-meganav-btn-mobile]"),
              s = e.querySelector("[lsg-subnav-groups]"),
              n = e.querySelectorAll("[lsg-subnav-item]"),
              l = e.querySelectorAll("[lsg-subnav-btn]"),
              r = e.querySelectorAll("[lsg-subnav-group]");
            t
              ? t.addEventListener("click", (i) => {
                  t.classList.contains("lsg-meganav-btn-mobile-active")
                    ? (t.classList.remove("lsg-meganav-btn-mobile-active"),
                      t.setAttribute("aria-expanded", !1),
                      e.setAttribute("aria-hidden", !0),
                      s.classList.remove("lsg-subnav-groups-active"),
                      l.forEach((e) => {
                        (function (e) {
                          let t = document.querySelector(
                              `[lsg-subnav-btn-mobile][lsg-subnav-handle="${e}"]`
                            ),
                            i = document.querySelector(
                              `[lsg-subnav-group][lsg-subnav-handle="${e}"]`
                            );
                          i &&
                            i.classList.remove(
                              "lsg-subnav-group-active-mobile"
                            ),
                            t && t.classList.remove("lsg-subnav-btn-active");
                        })(e.getAttribute("lsg-subnav-handle"));
                      }),
                      r.forEach((e) => {
                        e.classList.remove("lsg-subnav-group-active-mobile");
                      }))
                    : (u(),
                      t.classList.add("lsg-meganav-btn-mobile-active"),
                      t.setAttribute("aria-expanded", !0),
                      e.setAttribute("aria-hidden", !1),
                      s.classList.add("lsg-subnav-groups-active"));
                })
              : console.log(
                  "[LSG] lsg-meganav-btn-mobile not found, skipping."
                ),
              n.forEach((t) => {
                t.addEventListener("mouseenter", (s) => {
                  i(t.getAttribute("lsg-subnav-handle"), e);
                });
              }),
              l.forEach((t) => {
                t.addEventListener("click", (s) => {
                  let n = t.getAttribute("lsg-subnav-handle"),
                    l = t.classList.contains("lsg-subnav-btn-active");
                  if (t.getAttribute("lsg-subnav-btn-mobile")) {
                    if (l) {
                      let i = e.querySelector(
                        `[lsg-subnav-group][lsg-subnav-handle="${n}"]`
                      );
                      t.classList.remove("lsg-subnav-btn-active"),
                        i.classList.remove("lsg-subnav-group-active-mobile");
                      return;
                    }
                    i(n, e);
                  } else if (l) return;
                  i(n, e);
                });
              });
          }
          function i(e, t) {
            let i = t.querySelectorAll(".lsg-subnav-item-active"),
              s = t.querySelectorAll(".lsg-subnav-btn-active"),
              n = t.querySelector(".lsg-subnav-group-active"),
              l = t.querySelector(
                `[lsg-subnav-item][lsg-subnav-handle="${e}"]`
              ),
              r = t.querySelectorAll(
                `[lsg-subnav-btn][lsg-subnav-handle="${e}"]`
              ),
              o = t.querySelector(
                `[lsg-subnav-group][lsg-subnav-handle="${e}"]`
              );
            i.forEach((e) => {
              e.classList.remove("lsg-subnav-item-active");
            }),
              l.classList.add("lsg-subnav-item-active"),
              s.forEach((e) => {
                e.classList.remove("lsg-subnav-btn-active");
              }),
              n &&
                (n.classList.remove("lsg-subnav-group-active"),
                n.classList.remove("lsg-subnav-group-active-mobile")),
              r.forEach((e) => {
                e.classList.add("lsg-subnav-btn-active");
              }),
              o.classList.add("lsg-subnav-group-active"),
              o.classList.add("lsg-subnav-group-active-mobile");
          }
          t(e),
            document.addEventListener("shopify:section:load", (e) => {
              console.log("shopify:section:load");
              let i = e.target.querySelector(".lsg-meganav");
              i.classList.add("lsg-meganav-active"), t(i);
            }),
            document.addEventListener("shopify:section:select", (e) => {
              console.log("shopify:section:select");
              let t = e.target.querySelector(".lsg-meganav"),
                i = document.querySelector(".lsg-header");
              t.classList.add("lsg-meganav-active"),
                i
                  ? p(i)
                  : console.error(
                      "LSG Header not found! LSG MegaNav required LSG Header to function."
                    );
            }),
            document.addEventListener("shopify:block:select", (e) => {
              console.log("shopify:block:select");
              let t = e.target.parentElement,
                s = t.getAttribute("lsg-subnav-handle"),
                n = t.closest(".lsg-meganav"),
                l = n.querySelector("[lsg-meganav-btn]"),
                r = n.querySelector("[lsg-meganav-btn-mobile]"),
                o = n.querySelector("[lsg-subnav-groups]");
              n.classList.add("lsg-meganav-active"),
                l
                  ? l.classList.add("lsg-meganav-btn-active")
                  : (console.log("No megaNavBtnEl found, parentEl:"),
                    console.log(n)),
                r
                  ? r.classList.add("lsg-meganav-btn-mobile-active")
                  : (console.log("No megaNavBtnMobileEl found, parentEl:"),
                    console.log(n)),
                o
                  ? o.classList.add("lsg-subnav-groups-active")
                  : (console.log("No subNavGrpsEl found, parentEl:"),
                    console.log(n)),
                i(s, n);
            }),
            document.addEventListener("shopify:section:deselect", (e) => {
              console.log("shopify:section:deselect"),
                e.target.querySelector(".lsg-meganav");
              let t = document.querySelector(".lsg-header");
              t
                ? m(t)
                : console.error(
                    "LSG Header not found! LSG MegaNav required LSG Header to function."
                  );
            });
        });
      },
    }.init(),
    {
      init: () => {
        function t(t) {
          let i;
          let s = t.getAttribute("data-section-id"),
            n = JSON.parse(
              document.getElementById(`CarouselSettings-${s}`).textContent
            ),
            l = t.querySelector("[lsg-carousel]");
          if (l) {
            let s = t.querySelector("[lsg-carousel-nav]"),
              a = s.querySelector("[lsg-carousel-nav-prev]"),
              c =
                (s.querySelector("[lsg-carousel-nav-dots]"),
                s.querySelectorAll("[lsg-carousel-nav-dot]")),
              u = s.querySelector("[lsg-carousel-nav-next]");
            function r(e) {
              e.cells.forEach((e) => (e.element.style.height = ""));
              let t = e.cells.map((e) => e.element.offsetHeight),
                i = Math.max.apply(Math, t);
              e.cells.forEach((e) => (e.element.style.height = i + "px"));
            }
            function o(e) {
              c.forEach((e) => {
                e.parentElement.classList.remove("lsg-dot-selected");
              });
              let t = s.querySelector(`[lsg-carousel-nav-dot-index="${e}"]`);
              t && t.parentElement.classList.add("lsg-dot-selected"),
                a &&
                  u &&
                  (a.removeAttribute("disabled"),
                  u.removeAttribute("disabled"),
                  i.isWrapping || 0 !== e
                    ? i.isWrapping ||
                      e !== i.cells.length - 1 ||
                      u.setAttribute("disabled", !0)
                    : a.setAttribute("disabled", !0));
            }
            (n.prevNextButtons = !1),
              (n.pageDots = !1),
              (n.percentPosition = !1),
              (n.on = {
                change: (e) => {
                  o(e);
                },
              }),
              r((i = new /*@__PURE__*/ (e(d))(l, n))),
              (a = (s = t.querySelector("[lsg-carousel-nav]")).querySelector(
                "[lsg-carousel-nav-prev]"
              )),
              s.querySelector("[lsg-carousel-nav-dots]"),
              (c = s.querySelectorAll("[lsg-carousel-nav-dot]")),
              (u = s.querySelector("[lsg-carousel-nav-next]")),
              o(n.initialIndex),
              window.addEventListener("resize", () => {
                i.resize(),
                  i && l.clientWidth > i.slideableWidth
                    ? (i.cells.forEach((e) => (e.element.style.height = "")),
                      i.destroy())
                    : (i && i.isActive) || (i = new /*@__PURE__*/ (e(d))(l, n)),
                  r(i);
              }),
              a &&
                u &&
                (a.addEventListener("click", (e) => {
                  i.previous();
                }),
                u.addEventListener("click", (e) => {
                  i.next();
                })),
              c.forEach((e) => {
                e.addEventListener("click", (t) => {
                  let s = e.getAttribute("lsg-carousel-nav-dot-index");
                  i.select(s);
                });
              });
          }
        }
        document.querySelectorAll(".lsg-carousel-rebuild").forEach((e) => {
          t(e);
        }),
          document.addEventListener("shopify:section:load", (i) => {
            let s = i.detail.sectionId,
              n = i.target.querySelector(`[data-section-id="${s}"]`),
              l = n.querySelector("[lsg-carousel]"),
              r = /*@__PURE__*/ e(d).data(l);
            r?.destroy(), t(n);
          }),
          document.addEventListener("shopify:block:select", (t) => {
            let i = t.target.closest("[data-section-id]"),
              s = /*@__PURE__*/ e(d).data(i.querySelector("[lsg-carousel]")),
              n = [].indexOf.call(t.target.parentElement.children, t.target);
            s.select(n, !0, !0), s.resize();
          });
      },
    }.init(),
    {
      init: () => {
        document.querySelectorAll(".lsg-ingredient-explorer").forEach((e) => {
          let t = e.querySelector("[lsg-toggle-switch]"),
            i = e.querySelectorAll("button[lsg-dialog-handle]");
          if (t) {
            function s(t) {
              let i = e.querySelectorAll("[lsg-ie-info]"),
                s = e.querySelectorAll("[lsg-ie-right-wrapper]");
              i.forEach((e) => {
                e.style.display = "none";
              }),
                s.forEach((e) => {
                  e.style.display = "none";
                });
              let n = e.querySelector(`[lsg-ie-info][lsg-tab-handle="${t}"]`),
                l = e.querySelector(
                  `[lsg-ie-right-wrapper][lsg-tab-handle="${t}"]`
                );
              (n.style.display = "flex"), (l.style.display = "flex");
            }
            t.querySelectorAll('input[type="radio"]').forEach((e) => {
              e.addEventListener("change", (i) => {
                let n = e.getAttribute("lsg-tab-handle");
                s(n),
                  document
                    .querySelectorAll("[lsg-toggle-switch]")
                    .forEach((e) => {
                      if (e !== t) {
                        let t = e.querySelector(`input[lsg-tab-handle="${n}"]`);
                        t && t.nextElementSibling.click();
                      }
                    });
              }),
                e.checked && s(e.getAttribute("lsg-tab-handle"));
            });
          }
          i.forEach((t) => {
            let i = t.getAttribute("lsg-dialog-handle"),
              s = e.querySelector(`dialog[lsg-dialog-handle="${i}"]`);
            t.addEventListener("click", (e) => {
              s.showModal();
            });
          }),
            document
              .querySelectorAll(".lsg-ingredient-explorer__facts")
              .forEach((e) => {
                e.addEventListener("click", (t) => {
                  let i = t.target.classList;
                  for (let t = 0; t < i.length; t++)
                    "lsg-ingredient-explorer__facts" === i[t] && e.close();
                });
              });
        });
      },
    }.init(),
    {
      init: () => {
        document.querySelectorAll(".lsg-marquee").forEach((e) => {
          let t = e.querySelector("[lsg-slider]"),
            i = window.innerWidth;
          if (t) {
            let n = t?.getAttribute("dir") || "",
              l = new Flickity(t, {
                prevNextButtons: !1,
                pageDots: !1,
                wrapAround: !0,
                setGallerySize: !0,
                resize: !1,
                imagesLoaded: !0,
              });
            function s() {
              l && l.resize();
            }
            (l.x = 0),
              (function e() {
                "ltr" == n ? (l.x += 1) : (l.x -= 1),
                  l.settle(l.x),
                  window.requestAnimationFrame(e);
              })(),
              e.addEventListener("block:active", () => {
                s();
              }),
              window.addEventListener("resize", () => {
                window.innerWidth != i && ((i = window.innerWidth), s());
              });
          }
        });
      },
    }.init(),
    {
      init: () => {
        document.querySelectorAll(".lsg-toggle").forEach((e) => {
          let t = e.querySelector("[lsg-toggle-switch]");
          function i(t) {
            e.querySelectorAll("[lsg-toggle-tab]").forEach((e) => {
              e.style.display = "none";
            }),
              (e.querySelector(
                `[lsg-toggle-tab][lsg-tab-handle="${t}"]`
              ).style.display = "flex");
          }
          t.querySelectorAll('input[type="radio"]').forEach((e) => {
            e.addEventListener("change", (s) => {
              let n = e.getAttribute("lsg-tab-handle");
              i(n),
                document
                  .querySelectorAll("[lsg-toggle-switch]")
                  .forEach((e) => {
                    if (e !== t) {
                      let t = e.querySelector(`input[lsg-tab-handle="${n}"]`);
                      t && t.nextElementSibling.click();
                    }
                  });
            }),
              e.checked && i(e.getAttribute("lsg-tab-handle"));
          });
        });
      },
    }.init();
})();
